// // import React, { useState } from 'react';
// // import { useParams, Link } from 'react-router-dom';
// // import { 
// //   ArrowLeft,
// //   AlertCircle,
// //   CheckCircle,
// //   Phone,
// //   Mail,
// //   Calendar,
// //   ChevronDown,
// //   ChevronUp,
// //   Info,
// //   Shield,
// //   Heart,
// //   Activity,
// //   Clock,
// //   Users,
// //   Target,
// //   BookOpen,
// //   Stethoscope
// // } from 'lucide-react';

// // const ProcedureDetailPageRedesigned = () => {
// //   const { procedureId } = useParams();
// //   const [openFAQ, setOpenFAQ] = useState(null);
// //   const [activeTab, setActiveTab] = useState('symptoms');

// //   // Comprehensive procedure data (keeping the same data structure)
// //   const proceduresData = {
// //     'asthma': {
// //       title: "Asthma",
// //       category: "Chronic Respiratory Condition",
// //       tagline: "Comprehensive Asthma Management & Care",
// //       heroImage: "https://images.unsplash.com/photo-1584362917165-526a968579e8?w=1200&q=90",
// //       icon: "🫁",
// //       color: "#2C85B8",
// //       duration: "Ongoing Management",
      
// //       overview: "Asthma is a chronic respiratory condition that causes inflammation and narrowing of the airways, leading to difficulty breathing. Our comprehensive asthma management program provides personalized care through accurate diagnosis, effective treatment plans, and ongoing support to help you live a full, active life.",
      
// //       whatIsIt: "Asthma is a chronic inflammatory disease of the airways characterized by variable and recurring symptoms, reversible airflow obstruction, and bronchospasm. It affects people of all ages and can range from mild to severe, potentially life-threatening cases.",
      
// //       symptoms: [
// //         {
// //           name: "Wheezing",
// //           description: "A whistling sound when breathing, especially during exhalation"
// //         },
// //         {
// //           name: "Shortness of Breath",
// //           description: "Difficulty breathing or feeling like you can't get enough air"
// //         },
// //         {
// //           name: "Chest Tightness",
// //           description: "Feeling of pressure or constriction in the chest"
// //         },
// //         {
// //           name: "Persistent Coughing",
// //           description: "Frequent coughing, especially at night or early morning"
// //         },
// //         {
// //           name: "Difficulty Sleeping",
// //           description: "Breathing problems that wake you up or prevent sleep"
// //         },
// //         {
// //           name: "Exercise Intolerance",
// //           description: "Breathing difficulties during or after physical activity"
// //         }
// //       ],
      
// //       causes: [
// //         "Genetic predisposition and family history",
// //         "Environmental allergens (pollen, dust mites, pet dander)",
// //         "Respiratory infections, especially in childhood",
// //         "Air pollution and cigarette smoke exposure",
// //         "Occupational irritants and chemicals",
// //         "Cold air, exercise, and stress triggers"
// //       ],
      
// //       treatments: [
// //         {
// //           title: "Inhaler Therapy",
// //           description: "Quick-relief and long-term control medications using inhalers and spacers for effective drug delivery"
// //         },
// //         {
// //           title: "Nebulization",
// //           description: "Medication delivered as a mist for severe symptoms or young children who can't use inhalers"
// //         },
// //         {
// //           title: "Immunotherapy",
// //           description: "Allergy shots or sublingual tablets to reduce sensitivity to specific allergens"
// //         },
// //         {
// //           title: "Oral Medications",
// //           description: "Leukotriene modifiers, theophylline, and oral steroids for severe cases"
// //         },
// //         {
// //           title: "Biologic Therapies",
// //           description: "Advanced injectable medications for severe, uncontrolled asthma"
// //         },
// //         {
// //           title: "Lifestyle Management",
// //           description: "Trigger avoidance, breathing exercises, and asthma action plan development"
// //         }
// //       ],
      
// //       diagnosis: [
// //         "Detailed medical history and physical examination",
// //         "Spirometry to measure lung function",
// //         "Peak flow monitoring",
// //         "Chest X-ray to rule out other conditions",
// //         "Allergy testing to identify triggers",
// //         "Bronchial provocation tests if needed"
// //       ],
      
// //       prevention: [
// //         "Identify and avoid asthma triggers",
// //         "Take medications as prescribed",
// //         "Monitor breathing and symptoms daily",
// //         "Get vaccinated against flu and pneumonia",
// //         "Maintain a healthy weight",
// //         "Practice breathing exercises regularly"
// //       ],
      
// //       faqs: [
// //         {
// //           question: "Can asthma be cured?",
// //           answer: "Asthma cannot be cured, but it can be effectively managed. With proper treatment and trigger avoidance, most people with asthma can live normal, active lives with minimal symptoms."
// //         },
// //         {
// //           question: "Will I need to use an inhaler forever?",
// //           answer: "Many people need long-term inhaler use to control asthma. However, some children may outgrow their asthma, and medication needs can change over time. Your doctor will regularly assess whether you can reduce or modify your treatment."
// //         },
// //         {
// //           question: "Is it safe to exercise with asthma?",
// //           answer: "Yes, with proper management. Exercise is actually beneficial for people with asthma. Use your preventer inhaler before exercise, warm up properly, and have your rescue inhaler available. Inform your doctor about exercise-induced symptoms."
// //         },
// //         {
// //           question: "What should I do during an asthma attack?",
// //           answer: "Sit upright, stay calm, take your rescue inhaler (2-4 puffs), breathe slowly and deeply. If symptoms don't improve in 5-10 minutes, repeat. Call emergency services if there's no improvement or if you experience severe symptoms."
// //         },
// //         {
// //           question: "Can asthma get worse over time?",
// //           answer: "Without proper treatment, asthma can worsen and cause permanent airway changes. However, with good control and regular monitoring, most people maintain stable asthma throughout their lives."
// //         }
// //       ]
// //     },
// //     // Add other procedures here with same data structure
// //   };

// //   const procedure = proceduresData[procedureId];

// //   if (!procedure) {
// //     return (
// //       <div style={{padding: '4rem 2rem', textAlign: 'center', minHeight: '100vh'}}>
// //         <h2>Procedure not found</h2>
// //         <Link to="/procedures" style={{color: '#E86A33'}}>Back to Procedures</Link>
// //       </div>
// //     );
// //   }

// //   const toggleFAQ = (index) => {
// //     setOpenFAQ(openFAQ === index ? null : index);
// //   };

// //   return (
// //     <>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
// //         * {
// //           margin: 0;
// //           padding: 0;
// //           box-sizing: border-box;
// //         }

// //         body {
// //           font-family: 'Inter', sans-serif;
// //           color: #1a1a1a;
// //         }

// //         .procedure-detail-redesigned {
// //           width: 100%;
// //           min-height: 100vh;
// //           background: #FAFBFC;
// //         }

// //         /* Compact Hero Section */
// //         .procedure-hero-compact {
// //           position: relative;
// //           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
// //           padding: 3rem 2rem 2rem;
// //         }

// //         .procedure-hero-compact::before {
// //           content: '';
// //           position: absolute;
// //           top: 0;
// //           right: 0;
// //           width: 50%;
// //           height: 100%;
// //           background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="rgba(232,106,51,0.1)"/></svg>');
// //           background-size: 60px;
// //           opacity: 0.3;
// //         }

// //         .hero-content-compact {
// //           max-width: 1400px;
// //           margin: 0 auto;
// //           position: relative;
// //           z-index: 2;
// //         }

// //         .back-link-compact {
// //           display: inline-flex;
// //           align-items: center;
// //           gap: 0.5rem;
// //           color: white;
// //           text-decoration: none;
// //           font-weight: 600;
// //           margin-bottom: 2rem;
// //           padding: 0.6rem 1.2rem;
// //           background: rgba(255, 255, 255, 0.15);
// //           backdrop-filter: blur(10px);
// //           border-radius: 50px;
// //           font-size: 0.9rem;
// //           transition: all 0.3s ease;
// //         }

// //         .back-link-compact:hover {
// //           background: rgba(255, 255, 255, 0.25);
// //           transform: translateX(-5px);
// //         }

// //         .hero-grid {
// //           display: grid;
// //           grid-template-columns: auto 1fr auto;
// //           gap: 2rem;
// //           align-items: center;
// //         }

// //         .hero-icon-box {
// //           width: 100px;
// //           height: 100px;
// //           background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
// //           backdrop-filter: blur(20px);
// //           border-radius: 25px;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           font-size: 3.5rem;
// //           border: 2px solid rgba(255, 255, 255, 0.3);
// //         }

// //         .hero-text {
// //           color: white;
// //         }

// //         .category-tag {
// //           display: inline-block;
// //           padding: 0.4rem 1rem;
// //           background: rgba(232, 106, 51, 0.2);
// //           border-radius: 50px;
// //           font-size: 0.8rem;
// //           font-weight: 700;
// //           text-transform: uppercase;
// //           letter-spacing: 1px;
// //           margin-bottom: 0.8rem;
// //           color: #FFD700;
// //         }

// //         .hero-title-compact {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 2.8rem;
// //           font-weight: 800;
// //           margin-bottom: 0.5rem;
// //           line-height: 1.2;
// //         }

// //         .hero-subtitle {
// //           font-size: 1.1rem;
// //           opacity: 0.9;
// //           font-weight: 400;
// //         }

// //         .hero-meta {
// //           display: flex;
// //           flex-direction: column;
// //           gap: 0.8rem;
// //           padding: 1.5rem;
// //           background: rgba(255, 255, 255, 0.15);
// //           backdrop-filter: blur(20px);
// //           border-radius: 20px;
// //           border: 2px solid rgba(255, 255, 255, 0.2);
// //         }

// //         .meta-item-hero {
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //           color: white;
// //           font-size: 0.95rem;
// //           font-weight: 600;
// //         }

// //         /* Contact Strip */
// //         .contact-strip {
// //           background: white;
// //           border-bottom: 3px solid #E86A33;
// //           padding: 1.2rem 2rem;
// //           box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
// //         }

// //         .contact-strip-content {
// //           max-width: 1400px;
// //           margin: 0 auto;
// //           display: flex;
// //           justify-content: space-between;
// //           align-items: center;
// //           gap: 2rem;
// //           flex-wrap: wrap;
// //         }

// //         .contact-items {
// //           display: flex;
// //           gap: 2.5rem;
// //           flex-wrap: wrap;
// //         }

// //         .contact-item-strip {
// //           display: flex;
// //           align-items: center;
// //           gap: 0.8rem;
// //           color: #1B4965;
// //           font-weight: 600;
// //           font-size: 0.95rem;
// //         }

// //         .contact-icon {
// //           width: 40px;
// //           height: 40px;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           border-radius: 50%;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           color: white;
// //         }

// //         .contact-item-strip a {
// //           color: #1B4965;
// //           text-decoration: none;
// //           transition: color 0.3s ease;
// //         }

// //         .contact-item-strip a:hover {
// //           color: #E86A33;
// //         }

// //         .book-btn-strip {
// //           padding: 0.9rem 2.5rem;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           color: white;
// //           border: none;
// //           border-radius: 50px;
// //           font-weight: 700;
// //           font-size: 1rem;
// //           cursor: pointer;
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //           transition: all 0.3s ease;
// //           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
// //           text-decoration: none;
// //         }

// //         .book-btn-strip:hover {
// //           transform: translateY(-2px);
// //           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
// //         }

// //         /* Main Content - Full Width with Sidebar */
// //         .procedure-main {
// //           max-width: 1400px;
// //           margin: 0 auto;
// //           padding: 3rem 2rem;
// //           display: grid;
// //           grid-template-columns: 3fr 1fr;
// //           gap: 3rem;
// //         }

// //         /* Overview Card - Full Width */
// //         .overview-card {
// //           background: white;
// //           border-radius: 20px;
// //           padding: 3rem;
// //           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
// //           margin-bottom: 2rem;
// //           border-left: 5px solid #2C85B8;
// //         }

// //         .overview-title {
// //           font-size: 2rem;
// //           font-weight: 800;
// //           color: #1B4965;
// //           margin-bottom: 1.5rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         .overview-text {
// //           font-size: 1.05rem;
// //           line-height: 1.9;
// //           color: #444;
// //           margin-bottom: 1.5rem;
// //         }

// //         /* Tabbed Interface */
// //         .tabs-container {
// //           background: white;
// //           border-radius: 20px;
// //           overflow: hidden;
// //           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
// //           margin-bottom: 2rem;
// //         }

// //         .tabs-header {
// //           display: flex;
// //           background: #F8FAFB;
// //           border-bottom: 2px solid #E5E7EB;
// //         }

// //         .tab-button {
// //           flex: 1;
// //           padding: 1.2rem 1.5rem;
// //           background: transparent;
// //           border: none;
// //           font-weight: 700;
// //           font-size: 0.95rem;
// //           cursor: pointer;
// //           transition: all 0.3s ease;
// //           color: #666;
// //           position: relative;
// //         }

// //         .tab-button.active {
// //           color: #E86A33;
// //           background: white;
// //         }

// //         .tab-button.active::after {
// //           content: '';
// //           position: absolute;
// //           bottom: 0;
// //           left: 0;
// //           right: 0;
// //           height: 3px;
// //           background: linear-gradient(90deg, #E86A33, #FF9B6E);
// //         }

// //         .tab-button:hover:not(.active) {
// //           color: #1B4965;
// //           background: rgba(232, 106, 51, 0.05);
// //         }

// //         .tab-content {
// //           padding: 2.5rem;
// //         }

// //         /* Symptoms as Cards */
// //         .symptoms-cards {
// //           display: grid;
// //           grid-template-columns: repeat(2, 1fr);
// //           gap: 1.2rem;
// //         }

// //         .symptom-card-new {
// //           padding: 1.5rem;
// //           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
// //           border-radius: 15px;
// //           border: 2px solid #E5E7EB;
// //           transition: all 0.3s ease;
// //           position: relative;
// //           overflow: hidden;
// //         }

// //         .symptom-card-new::before {
// //           content: '';
// //           position: absolute;
// //           top: 0;
// //           left: 0;
// //           width: 4px;
// //           height: 0;
// //           background: linear-gradient(to bottom, #E86A33, #FF9B6E);
// //           transition: height 0.3s ease;
// //         }

// //         .symptom-card-new:hover {
// //           border-color: #E86A33;
// //           transform: translateY(-3px);
// //           box-shadow: 0 8px 25px rgba(232, 106, 51, 0.15);
// //         }

// //         .symptom-card-new:hover::before {
// //           height: 100%;
// //         }

// //         .symptom-name-new {
// //           font-size: 1.1rem;
// //           font-weight: 700;
// //           color: #1B4965;
// //           margin-bottom: 0.6rem;
// //           display: flex;
// //           align-items: center;
// //           gap: 0.6rem;
// //         }

// //         .symptom-desc-new {
// //           font-size: 0.95rem;
// //           line-height: 1.6;
// //           color: #666;
// //         }

// //         /* Treatments as Timeline */
// //         .treatment-timeline {
// //           position: relative;
// //           padding-left: 2rem;
// //         }

// //         .treatment-timeline::before {
// //           content: '';
// //           position: absolute;
// //           left: 0;
// //           top: 0;
// //           bottom: 0;
// //           width: 3px;
// //           background: linear-gradient(to bottom, #2C85B8, #62B6CB);
// //         }

// //         .treatment-item {
// //           position: relative;
// //           margin-bottom: 2rem;
// //           padding-left: 2rem;
// //         }

// //         .treatment-item::before {
// //           content: '';
// //           position: absolute;
// //           left: -2.5rem;
// //           top: 0.5rem;
// //           width: 18px;
// //           height: 18px;
// //           background: white;
// //           border: 4px solid #2C85B8;
// //           border-radius: 50%;
// //           box-shadow: 0 0 0 4px rgba(44, 133, 184, 0.1);
// //         }

// //         .treatment-title-new {
// //           font-size: 1.2rem;
// //           font-weight: 700;
// //           color: #1B4965;
// //           margin-bottom: 0.5rem;
// //         }

// //         .treatment-desc-new {
// //           font-size: 1rem;
// //           line-height: 1.7;
// //           color: #666;
// //         }

// //         /* Simple Lists with Icons */
// //         .icon-list {
// //           display: grid;
// //           gap: 1rem;
// //         }

// //         .icon-list-item {
// //           display: flex;
// //           align-items: flex-start;
// //           gap: 1rem;
// //           padding: 1rem 1.2rem;
// //           background: #F8FAFB;
// //           border-radius: 12px;
// //           transition: all 0.3s ease;
// //         }

// //         .icon-list-item:hover {
// //           background: white;
// //           box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
// //           transform: translateX(8px);
// //         }

// //         .list-icon-new {
// //           width: 24px;
// //           height: 24px;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           border-radius: 50%;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           color: white;
// //           flex-shrink: 0;
// //           margin-top: 0.1rem;
// //         }

// //         /* FAQ Redesigned */
// //         .faq-section {
// //           margin-top: 2rem;
// //         }

// //         .faq-item-new {
// //           background: white;
// //           border: 2px solid #E5E7EB;
// //           border-radius: 15px;
// //           margin-bottom: 1rem;
// //           overflow: hidden;
// //           transition: all 0.3s ease;
// //         }

// //         .faq-item-new.open {
// //           border-color: #2C85B8;
// //           box-shadow: 0 4px 20px rgba(44, 133, 184, 0.1);
// //         }

// //         .faq-question-new {
// //           padding: 1.5rem 2rem;
// //           display: flex;
// //           justify-content: space-between;
// //           align-items: center;
// //           cursor: pointer;
// //           font-weight: 700;
// //           font-size: 1.05rem;
// //           color: #1B4965;
// //           transition: all 0.3s ease;
// //           background: #F8FAFB;
// //         }

// //         .faq-item-new.open .faq-question-new {
// //           background: white;
// //           color: #2C85B8;
// //         }

// //         .faq-answer-new {
// //           padding: 0 2rem 1.5rem;
// //           font-size: 1rem;
// //           line-height: 1.8;
// //           color: #666;
// //         }

// //         /* Sidebar - Info Cards */
// //         .sidebar-new {
// //           display: flex;
// //           flex-direction: column;
// //           gap: 1.5rem;
// //         }

// //         .info-card {
// //           background: white;
// //           border-radius: 20px;
// //           padding: 2rem;
// //           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
// //           border-top: 4px solid #2C85B8;
// //         }

// //         .info-card-title {
// //           font-size: 1.3rem;
// //           font-weight: 800;
// //           color: #1B4965;
// //           margin-bottom: 1.5rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         .info-row {
// //           display: flex;
// //           justify-content: space-between;
// //           padding: 1rem 0;
// //           border-bottom: 1px solid #F0F0F0;
// //         }

// //         .info-row:last-child {
// //           border-bottom: none;
// //         }

// //         .info-label {
// //           font-weight: 600;
// //           color: #666;
// //           font-size: 0.9rem;
// //         }

// //         .info-value {
// //           font-weight: 700;
// //           color: #1B4965;
// //           text-align: right;
// //         }

// //         /* CTA Card */
// //         .cta-card-new {
// //           background: linear-gradient(135deg, #2C85B8 0%, #1B4965 100%);
// //           color: white;
// //           text-align: center;
// //           position: relative;
// //           overflow: hidden;
// //         }

// //         .cta-card-new::before {
// //           content: '';
// //           position: absolute;
// //           top: -50%;
// //           right: -50%;
// //           width: 200%;
// //           height: 200%;
// //           background: radial-gradient(circle, rgba(232, 106, 51, 0.2) 0%, transparent 70%);
// //           animation: pulse 3s ease-in-out infinite;
// //         }

// //         @keyframes pulse {
// //           0%, 100% { transform: scale(1); opacity: 0.5; }
// //           50% { transform: scale(1.1); opacity: 0.8; }
// //         }

// //         .cta-card-content {
// //           position: relative;
// //           z-index: 2;
// //         }

// //         .cta-title-new {
// //           font-size: 1.6rem;
// //           font-weight: 800;
// //           margin-bottom: 1rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         .cta-text-new {
// //           font-size: 0.95rem;
// //           opacity: 0.95;
// //           margin-bottom: 1.5rem;
// //           line-height: 1.6;
// //         }

// //         .cta-contacts {
// //           display: flex;
// //           flex-direction: column;
// //           gap: 0.8rem;
// //           margin-bottom: 1.5rem;
// //         }

// //         .cta-contact-item {
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           gap: 0.8rem;
// //           padding: 0.8rem;
// //           background: rgba(255, 255, 255, 0.1);
// //           border-radius: 12px;
// //           font-weight: 600;
// //           font-size: 0.9rem;
// //         }

// //         .cta-contact-item a {
// //           color: white;
// //           text-decoration: none;
// //         }

// //         .cta-button-new {
// //           width: 100%;
// //           padding: 1rem;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           color: white;
// //           border: none;
// //           border-radius: 50px;
// //           font-weight: 700;
// //           font-size: 1rem;
// //           cursor: pointer;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           gap: 0.7rem;
// //           transition: all 0.3s ease;
// //           text-decoration: none;
// //         }

// //         .cta-button-new:hover {
// //           transform: translateY(-2px);
// //           box-shadow: 0 6px 20px rgba(232, 106, 51, 0.4);
// //         }

// //         /* Responsive */
// //         @media (max-width: 1024px) {
// //           .procedure-main {
// //             grid-template-columns: 1fr;
// //           }

// //           .hero-grid {
// //             grid-template-columns: 1fr;
// //             text-align: center;
// //           }

// //           .hero-icon-box {
// //             margin: 0 auto;
// //           }

// //           .hero-meta {
// //             margin: 0 auto;
// //             max-width: 300px;
// //           }

// //           .symptoms-cards {
// //             grid-template-columns: 1fr;
// //           }
// //         }

// //         @media (max-width: 768px) {
// //           .hero-title-compact {
// //             font-size: 2rem;
// //           }

// //           .contact-strip-content {
// //             flex-direction: column;
// //             align-items: flex-start;
// //           }

// //           .overview-card,
// //           .tab-content {
// //             padding: 2rem;
// //           }

// //           .tabs-header {
// //             flex-wrap: wrap;
// //           }

// //           .tab-button {
// //             flex: 1 1 50%;
// //           }
// //         }
// //       `}</style>

// //       <div className="procedure-detail-redesigned">
// //         {/* Compact Hero */}
// //         <section className="procedure-hero-compact">
// //           <div className="hero-content-compact">
// //             <Link to="/procedures" className="back-link-compact">
// //               <ArrowLeft size={18} />
// //               Back to Procedures
// //             </Link>

// //             <div className="hero-grid">
// //               <div className="hero-icon-box">
// //                 {procedure.icon}
// //               </div>

// //               <div className="hero-text">
// //                 <div className="category-tag">{procedure.category}</div>
// //                 <h1 className="hero-title-compact">{procedure.title}</h1>
// //                 <p className="hero-subtitle">{procedure.tagline}</p>
// //               </div>

// //               <div className="hero-meta">
// //                 <div className="meta-item-hero">
// //                   <Clock size={20} />
// //                   <span>{procedure.duration}</span>
// //                 </div>
// //                 <div className="meta-item-hero">
// //                   <Stethoscope size={20} />
// //                   <span>Expert Care</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* Contact Strip */}
// //         <div className="contact-strip">
// //           <div className="contact-strip-content">
// //             <div className="contact-items">
// //               <div className="contact-item-strip">
// //                 <div className="contact-icon">
// //                   <Phone size={18} />
// //                 </div>
// //                 <a href="tel:+911234567890">+91 123 456 7890</a>
// //               </div>
// //               <div className="contact-item-strip">
// //                 <div className="contact-icon">
// //                   <Phone size={18} />
// //                 </div>
// //                 <a href="tel:+910987654321">+91 098 765 4321</a>
// //               </div>
// //               <div className="contact-item-strip">
// //                 <div className="contact-icon">
// //                   <Mail size={18} />
// //                 </div>
// //                 <a href="mailto:appointments@vayulungcare.com">appointments@vayulungcare.com</a>
// //               </div>
// //             </div>
// //             <a href="/contact" className="book-btn-strip">
// //               <Calendar size={20} />
// //               Book Appointment
// //             </a>
// //           </div>
// //         </div>

// //         {/* Main Content */}
// //         <div className="procedure-main">
// //           <div>
// //             {/* Overview */}
// //             <div className="overview-card">
// //               <h2 className="overview-title">Understanding {procedure.title}</h2>
// //               <p className="overview-text">{procedure.overview}</p>
// //               <p className="overview-text">{procedure.whatIsIt}</p>
// //             </div>

// //             {/* Tabbed Content */}
// //             <div className="tabs-container">
// //               <div className="tabs-header">
// //                 <button 
// //                   className={`tab-button ${activeTab === 'symptoms' ? 'active' : ''}`}
// //                   onClick={() => setActiveTab('symptoms')}
// //                 >
// //                   <AlertCircle size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
// //                   Symptoms
// //                 </button>
// //                 <button 
// //                   className={`tab-button ${activeTab === 'causes' ? 'active' : ''}`}
// //                   onClick={() => setActiveTab('causes')}
// //                 >
// //                   <Info size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
// //                   Causes
// //                 </button>
// //                 <button 
// //                   className={`tab-button ${activeTab === 'treatment' ? 'active' : ''}`}
// //                   onClick={() => setActiveTab('treatment')}
// //                 >
// //                   <Shield size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
// //                   Treatment
// //                 </button>
// //                 <button 
// //                   className={`tab-button ${activeTab === 'prevention' ? 'active' : ''}`}
// //                   onClick={() => setActiveTab('prevention')}
// //                 >
// //                   <Heart size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
// //                   Prevention
// //                 </button>
// //               </div>

// //               <div className="tab-content">
// //                 {/* Symptoms Tab */}
// //                 {activeTab === 'symptoms' && (
// //                   <div className="symptoms-cards">
// //                     {procedure.symptoms.map((symptom, index) => (
// //                       <div key={index} className="symptom-card-new">
// //                         <div className="symptom-name-new">
// //                           <AlertCircle size={18} style={{color: '#E86A33'}} />
// //                           {symptom.name}
// //                         </div>
// //                         <div className="symptom-desc-new">{symptom.description}</div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}

// //                 {/* Causes Tab */}
// //                 {activeTab === 'causes' && (
// //                   <div className="icon-list">
// //                     {procedure.causes.map((cause, index) => (
// //                       <div key={index} className="icon-list-item">
// //                         <div className="list-icon-new">
// //                           <AlertCircle size={14} />
// //                         </div>
// //                         <span>{cause}</span>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}

// //                 {/* Treatment Tab */}
// //                 {activeTab === 'treatment' && (
// //                   <div className="treatment-timeline">
// //                     {procedure.treatments.map((treatment, index) => (
// //                       <div key={index} className="treatment-item">
// //                         <div className="treatment-title-new">{treatment.title}</div>
// //                         <div className="treatment-desc-new">{treatment.description}</div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}

// //                 {/* Prevention Tab */}
// //                 {activeTab === 'prevention' && (
// //                   <div className="icon-list">
// //                     {procedure.prevention.map((tip, index) => (
// //                       <div key={index} className="icon-list-item">
// //                         <div className="list-icon-new">
// //                           <CheckCircle size={14} />
// //                         </div>
// //                         <span>{tip}</span>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>
// //             </div>

// //             {/* FAQ Section */}
// //             <div className="tabs-container">
// //               <div className="tabs-header">
// //                 <div className="tab-button active">
// //                   <BookOpen size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
// //                   Frequently Asked Questions
// //                 </div>
// //               </div>
// //               <div className="tab-content">
// //                 <div className="faq-section">
// //                   {procedure.faqs.map((faq, index) => (
// //                     <div 
// //                       key={index} 
// //                       className={`faq-item-new ${openFAQ === index ? 'open' : ''}`}
// //                     >
// //                       <div 
// //                         className="faq-question-new"
// //                         onClick={() => toggleFAQ(index)}
// //                       >
// //                         <span>{faq.question}</span>
// //                         {openFAQ === index ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
// //                       </div>
// //                       {openFAQ === index && (
// //                         <div className="faq-answer-new">
// //                           {faq.answer}
// //                         </div>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Sidebar */}
// //           <div className="sidebar-new">
// //             {/* Quick Info */}
// //             <div className="info-card">
// //               <h3 className="info-card-title">Quick Information</h3>
// //               <div className="info-row">
// //                 <span className="info-label">Duration</span>
// //                 <span className="info-value">{procedure.duration}</span>
// //               </div>
// //               <div className="info-row">
// //                 <span className="info-label">Category</span>
// //                 <span className="info-value">{procedure.category}</span>
// //               </div>
// //               <div className="info-row">
// //                 <span className="info-label">Specialist</span>
// //                 <span className="info-value">Available</span>
// //               </div>
// //             </div>

// //             {/* CTA Card */}
// //             <div className="info-card cta-card-new">
// //               <div className="cta-card-content">
// //                 <h3 className="cta-title-new">Need Consultation?</h3>
// //                 <p className="cta-text-new">
// //                   Get expert medical advice for your condition
// //                 </p>
                
// //                 <div className="cta-contacts">
// //                   <div className="cta-contact-item">
// //                     <Phone size={16} />
// //                     <a href="tel:+911234567890">+91 123 456 7890</a>
// //                   </div>
// //                   <div className="cta-contact-item">
// //                     <Mail size={16} />
// //                     <a href="mailto:appointments@vayulungcare.com">Email Us</a>
// //                   </div>
// //                 </div>

// //                 <a href="/contact" className="cta-button-new">
// //                   <Calendar size={20} />
// //                   Schedule Now
// //                 </a>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default ProcedureDetailPageRedesigned;

// import React, { useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { 
//   ArrowLeft,
//   AlertCircle,
//   CheckCircle,
//   Phone,
//   Mail,
//   Calendar,
//   ChevronDown,
//   ChevronUp,
//   Info,
//   Shield,
//   Heart,
//   Activity,
//   Clock,
//   Users,
//   Target,
//   BookOpen,
//   Stethoscope
// } from 'lucide-react';

// const ProcedureDetailPageRedesigned = () => {
//   const { procedureId } = useParams();
//   const [openFAQ, setOpenFAQ] = useState(null);
//   const [activeTab, setActiveTab] = useState('symptoms');

//   // Comprehensive procedure data (keeping the same data structure)
//   const proceduresData = {
//     'asthma': {
//       title: "Asthma",
//       category: "Chronic Respiratory Condition",
//       tagline: "Comprehensive Asthma Management & Care",
//       heroImage: "https://images.unsplash.com/photo-1584362917165-526a968579e8?w=1200&q=90",
//       icon: "🫁",
//       color: "#2C85B8",
//       duration: "Ongoing Management",
      
//       overview: "Asthma is a chronic respiratory condition that causes inflammation and narrowing of the airways, leading to difficulty breathing. Our comprehensive asthma management program provides personalized care through accurate diagnosis, effective treatment plans, and ongoing support to help you live a full, active life.",
      
//       whatIsIt: "Asthma is a chronic inflammatory disease of the airways characterized by variable and recurring symptoms, reversible airflow obstruction, and bronchospasm. It affects people of all ages and can range from mild to severe, potentially life-threatening cases.",
      
//       symptoms: [
//         {
//           name: "Wheezing",
//           description: "A whistling sound when breathing, especially during exhalation"
//         },
//         {
//           name: "Shortness of Breath",
//           description: "Difficulty breathing or feeling like you can't get enough air"
//         },
//         {
//           name: "Chest Tightness",
//           description: "Feeling of pressure or constriction in the chest"
//         },
//         {
//           name: "Persistent Coughing",
//           description: "Frequent coughing, especially at night or early morning"
//         },
//         {
//           name: "Difficulty Sleeping",
//           description: "Breathing problems that wake you up or prevent sleep"
//         },
//         {
//           name: "Exercise Intolerance",
//           description: "Breathing difficulties during or after physical activity"
//         }
//       ],
      
//       causes: [
//         "Genetic predisposition and family history",
//         "Environmental allergens (pollen, dust mites, pet dander)",
//         "Respiratory infections, especially in childhood",
//         "Air pollution and cigarette smoke exposure",
//         "Occupational irritants and chemicals",
//         "Cold air, exercise, and stress triggers"
//       ],
      
//       treatments: [
//         {
//           title: "Inhaler Therapy",
//           description: "Quick-relief and long-term control medications using inhalers and spacers for effective drug delivery"
//         },
//         {
//           title: "Nebulization",
//           description: "Medication delivered as a mist for severe symptoms or young children who can't use inhalers"
//         },
//         {
//           title: "Immunotherapy",
//           description: "Allergy shots or sublingual tablets to reduce sensitivity to specific allergens"
//         },
//         {
//           title: "Oral Medications",
//           description: "Leukotriene modifiers, theophylline, and oral steroids for severe cases"
//         },
//         {
//           title: "Biologic Therapies",
//           description: "Advanced injectable medications for severe, uncontrolled asthma"
//         },
//         {
//           title: "Lifestyle Management",
//           description: "Trigger avoidance, breathing exercises, and asthma action plan development"
//         }
//       ],
      
//       diagnosis: [
//         "Detailed medical history and physical examination",
//         "Spirometry to measure lung function",
//         "Peak flow monitoring",
//         "Chest X-ray to rule out other conditions",
//         "Allergy testing to identify triggers",
//         "Bronchial provocation tests if needed"
//       ],
      
//       prevention: [
//         "Identify and avoid asthma triggers",
//         "Take medications as prescribed",
//         "Monitor breathing and symptoms daily",
//         "Get vaccinated against flu and pneumonia",
//         "Maintain a healthy weight",
//         "Practice breathing exercises regularly"
//       ],
      
//       faqs: [
//         {
//           question: "Can asthma be cured?",
//           answer: "Asthma cannot be cured, but it can be effectively managed. With proper treatment and trigger avoidance, most people with asthma can live normal, active lives with minimal symptoms."
//         },
//         {
//           question: "Will I need to use an inhaler forever?",
//           answer: "Many people need long-term inhaler use to control asthma. However, some children may outgrow their asthma, and medication needs can change over time. Your doctor will regularly assess whether you can reduce or modify your treatment."
//         },
//         {
//           question: "Is it safe to exercise with asthma?",
//           answer: "Yes, with proper management. Exercise is actually beneficial for people with asthma. Use your preventer inhaler before exercise, warm up properly, and have your rescue inhaler available. Inform your doctor about exercise-induced symptoms."
//         },
//         {
//           question: "What should I do during an asthma attack?",
//           answer: "Sit upright, stay calm, take your rescue inhaler (2-4 puffs), breathe slowly and deeply. If symptoms don't improve in 5-10 minutes, repeat. Call emergency services if there's no improvement or if you experience severe symptoms."
//         },
//         {
//           question: "Can asthma get worse over time?",
//           answer: "Without proper treatment, asthma can worsen and cause permanent airway changes. However, with good control and regular monitoring, most people maintain stable asthma throughout their lives."
//         }
//       ]
//     },
    
//     'allergies': {
//       title: "Allergies",
//       category: "Immune System Response",
//       tagline: "Expert Allergy Diagnosis & Treatment",
//       heroImage: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1200&q=90",
//       icon: "🤧",
//       color: "#FF9B6E",
//       duration: "Varies by Type",
      
//       overview: "Allergies occur when your immune system reacts to a foreign substance that doesn't cause a reaction in most people. Our comprehensive allergy care includes advanced testing, personalized treatment plans, and immunotherapy to help you manage symptoms and improve your quality of life.",
      
//       whatIsIt: "An allergy is an immune system response to a substance (allergen) that is usually harmless. When you have allergies, your immune system makes antibodies that identify a particular allergen as harmful, triggering inflammation and various symptoms throughout the body.",
      
//       symptoms: [
//         {
//           name: "Sneezing & Runny Nose",
//           description: "Frequent sneezing and nasal discharge, especially seasonal"
//         },
//         {
//           name: "Itchy, Watery Eyes",
//           description: "Red, irritated eyes with excessive tearing"
//         },
//         {
//           name: "Skin Reactions",
//           description: "Hives, eczema, or contact dermatitis with itching"
//         },
//         {
//           name: "Nasal Congestion",
//           description: "Blocked nose and sinus pressure"
//         },
//         {
//           name: "Throat Irritation",
//           description: "Scratchy throat and post-nasal drip"
//         },
//         {
//           name: "Digestive Issues",
//           description: "Nausea, vomiting, or diarrhea from food allergies"
//         }
//       ],
      
//       causes: [
//         "Airborne allergens (pollen, dust mites, mold)",
//         "Food allergies (nuts, shellfish, milk, eggs)",
//         "Insect stings (bee, wasp venom)",
//         "Medications (penicillin, aspirin)",
//         "Latex and other materials",
//         "Pet dander and animal proteins"
//       ],
      
//       treatments: [
//         {
//           title: "Comprehensive Allergy Testing",
//           description: "Skin prick tests and blood tests to identify specific allergens causing your symptoms"
//         },
//         {
//           title: "Immunotherapy",
//           description: "Allergy shots or sublingual tablets to gradually desensitize your immune system"
//         },
//         {
//           title: "Antihistamines",
//           description: "Oral and nasal antihistamines to block histamine and relieve symptoms"
//         },
//         {
//           title: "Nasal Corticosteroids",
//           description: "Nasal sprays to reduce inflammation and prevent allergy symptoms"
//         },
//         {
//           title: "Epinephrine Auto-injectors",
//           description: "Emergency treatment for severe allergic reactions (anaphylaxis)"
//         },
//         {
//           title: "Avoidance Strategies",
//           description: "Personalized plans to minimize exposure to identified allergens"
//         }
//       ],
      
//       diagnosis: [
//         "Detailed symptom history and triggers",
//         "Skin prick testing for immediate allergies",
//         "Blood tests (IgE antibody testing)",
//         "Patch testing for contact allergies",
//         "Food elimination diets if needed",
//         "Challenge tests under medical supervision"
//       ],
      
//       prevention: [
//         "Identify and avoid known allergens",
//         "Keep windows closed during high pollen days",
//         "Use HEPA filters in home",
//         "Wash bedding in hot water weekly",
//         "Remove shoes at door to avoid tracking allergens",
//         "Consider allergy-proof bedding covers"
//       ],
      
//       faqs: [
//         {
//           question: "Can allergies develop later in life?",
//           answer: "Yes, you can develop new allergies at any age. While many allergies begin in childhood, it's not uncommon for adults to develop allergies to substances they were previously tolerant of."
//         },
//         {
//           question: "How long does immunotherapy take to work?",
//           answer: "Most people see improvement within 3-6 months of starting immunotherapy, but it typically takes 3-5 years of treatment for long-lasting effects. Some people may need to continue treatment longer for optimal results."
//         },
//         {
//           question: "Are allergy medications safe for long-term use?",
//           answer: "Yes, most allergy medications are safe for long-term use when taken as directed. However, regular follow-up with your doctor is important to assess effectiveness and adjust treatment as needed."
//         },
//         {
//           question: "What's the difference between allergies and cold?",
//           answer: "Allergies cause itchy eyes, nose, and throat, with clear, thin nasal discharge, lasting as long as you're exposed to the allergen. Colds cause body aches, fever, and thick nasal discharge, typically lasting 7-10 days."
//         },
//         {
//           question: "Can I outgrow my allergies?",
//           answer: "Some children outgrow certain allergies, especially food allergies like milk and egg. However, respiratory allergies often persist into adulthood, though symptoms may change in severity over time."
//         }
//       ]
//     },

//     'snoring': {
//       title: "Snoring & Sleep Apnea",
//       category: "Sleep Disorder Management",
//       tagline: "Advanced Sleep Breathing Solutions",
//       heroImage: "https://images.unsplash.com/photo-1541480551145-2370a440d585?w=1200&q=90",
//       icon: "😴",
//       color: "#1B4965",
//       duration: "Ongoing Management",
      
//       overview: "Sleep apnea is a serious sleep disorder where breathing repeatedly stops and starts during sleep. We provide comprehensive diagnosis through sleep studies and offer various treatment options including CPAP therapy, oral appliances, and surgical interventions.",
      
//       whatIsIt: "Sleep apnea is a potentially serious sleep disorder characterized by repeated breathing interruptions during sleep. The most common type, obstructive sleep apnea (OSA), occurs when throat muscles intermittently relax and block the airway during sleep.",
      
//       symptoms: [
//         {
//           name: "Loud Snoring",
//           description: "Persistent loud snoring that disturbs sleep partners"
//         },
//         {
//           name: "Breathing Cessation",
//           description: "Episodes of stopped breathing during sleep (observed by others)"
//         },
//         {
//           name: "Gasping for Air",
//           description: "Abrupt awakenings accompanied by gasping or choking"
//         },
//         {
//           name: "Morning Headache",
//           description: "Waking up with headaches"
//         },
//         {
//           name: "Excessive Daytime Sleepiness",
//           description: "Difficulty staying awake during the day"
//         },
//         {
//           name: "Irritability",
//           description: "Mood changes, irritability, or depression"
//         }
//       ],
      
//       causes: [
//         "Excess weight and obesity",
//         "Neck circumference and anatomy",
//         "Narrowed airway",
//         "Being male (risk increases for women after menopause)",
//         "Family history and genetics",
//         "Alcohol and sedative use before bed"
//       ],
      
//       treatments: [
//         {
//           title: "CPAP Therapy",
//           description: "Continuous Positive Airway Pressure machine keeps airways open during sleep"
//         },
//         {
//           title: "Oral Appliances",
//           description: "Custom-fitted devices that keep throat open by bringing jaw forward"
//         },
//         {
//           title: "Lifestyle Modifications",
//           description: "Weight loss, positional therapy, avoiding alcohol and sedatives"
//         },
//         {
//           title: "Surgical Options",
//           description: "Tissue removal, jaw repositioning, or implants for severe cases"
//         },
//         {
//           title: "BiPAP Therapy",
//           description: "Bilevel Positive Airway Pressure for those who can't tolerate CPAP"
//         },
//         {
//           title: "Hypoglossal Nerve Stimulation",
//           description: "Implanted device that stimulates nerve controlling tongue movement"
//         }
//       ],
      
//       diagnosis: [
//         "Sleep history and symptoms assessment",
//         "Polysomnography (overnight sleep study)",
//         "Home sleep apnea testing",
//         "Physical examination of mouth and throat",
//         "Epworth Sleepiness Scale",
//         "Oxygen saturation monitoring"
//       ],
      
//       prevention: [
//         "Maintain healthy weight",
//         "Exercise regularly",
//         "Avoid alcohol and sedatives before bed",
//         "Sleep on your side",
//         "Keep nasal passages open at night",
//         "Quit smoking"
//       ],
      
//       faqs: [
//         {
//           question: "Is sleep apnea dangerous?",
//           answer: "Yes, untreated sleep apnea can lead to high blood pressure, heart problems, type 2 diabetes, liver problems, and increased risk of accidents due to daytime drowsiness."
//         },
//         {
//           question: "Will I need to use CPAP forever?",
//           answer: "Many people need long-term CPAP use. However, if you lose significant weight or undergo successful surgery, you may be able to reduce or stop treatment."
//         },
//         {
//           question: "Can children have sleep apnea?",
//           answer: "Yes, children can develop sleep apnea, often due to enlarged tonsils and adenoids. Treatment may include surgical removal."
//         },
//         {
//           question: "How long does it take to adjust to CPAP?",
//           answer: "Most people adapt within 2-4 weeks. Initially it may feel uncomfortable, but consistent use and proper mask fitting help with adjustment."
//         },
//         {
//           question: "Can sleep apnea be cured?",
//           answer: "While OSA can be effectively managed, it's rarely 'cured.' Weight loss can sometimes eliminate mild OSA, and surgery may help some cases."
//         }
//       ]
//     },

//     'adenoids': {
//       title: "Adenoids",
//       category: "Lymphoid Tissue Disorder",
//       tagline: "Expert Adenoid Care for Children & Adults",
//       heroImage: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=90",
//       icon: "👶",
//       color: "#E86A33",
//       duration: "Varies",
      
//       overview: "Enlarged adenoids can cause breathing difficulties, especially in children. We provide comprehensive diagnosis and treatment including medical management and minimally invasive surgical options when necessary.",
      
//       whatIsIt: "Adenoids are glands located in the throat behind the nose. They help fight infections in infants and young children but typically shrink by adolescence. When enlarged, they can block airways and cause various symptoms.",
      
//       symptoms: [
//         {
//           name: "Mouth Breathing",
//           description: "Breathing through mouth instead of nose, especially during sleep"
//         },
//         {
//           name: "Loud Snoring",
//           description: "Persistent snoring in children"
//         },
//         {
//           name: "Nasal Congestion",
//           description: "Stuffy nose despite no cold or allergies"
//         },
//         {
//           name: "Recurrent Ear Infections",
//           description: "Frequent middle ear infections"
//         },
//         {
//           name: "Sleep Disturbances",
//           description: "Restless sleep and sleep apnea"
//         },
//         {
//           name: "Nasal Speech",
//           description: "Talking through nose with muffled voice"
//         }
//       ],
      
//       causes: [
//         "Viral and bacterial infections",
//         "Allergies",
//         "Genetics and family history",
//         "Exposure to irritants",
//         "Congenital enlargement",
//         "Chronic inflammation"
//       ],
      
//       treatments: [
//         {
//           title: "Antibiotics",
//           description: "For bacterial infections causing adenoid inflammation"
//         },
//         {
//           title: "Nasal Steroid Sprays",
//           description: "To reduce inflammation and swelling"
//         },
//         {
//           title: "Adenoidectomy",
//           description: "Surgical removal of adenoids for persistent problems"
//         },
//         {
//           title: "Watchful Waiting",
//           description: "Monitoring mild cases as adenoids may shrink naturally with age"
//         },
//         {
//           title: "Allergy Management",
//           description: "Treating underlying allergies to reduce adenoid swelling"
//         },
//         {
//           title: "Pain Management",
//           description: "Managing discomfort during acute infections"
//         }
//       ],
      
//       diagnosis: [
//         "Physical examination",
//         "Medical history review",
//         "Nasal endoscopy",
//         "X-ray or CT scan",
//         "Sleep study if apnea suspected",
//         "Allergy testing if indicated"
//       ],
      
//       prevention: [
//         "Practice good hygiene",
//         "Avoid exposure to secondhand smoke",
//         "Manage allergies effectively",
//         "Maintain healthy immune system",
//         "Regular medical check-ups",
//         "Avoid known irritants"
//       ],
      
//       faqs: [
//         {
//           question: "At what age do adenoids typically shrink?",
//           answer: "Adenoids usually start shrinking around age 5-7 and continue to decrease in size through adolescence. By adulthood, they're typically very small."
//         },
//         {
//           question: "Is adenoid surgery safe for children?",
//           answer: "Yes, adenoidectomy is a very safe and common procedure for children. It's performed under general anesthesia and most children recover quickly within a few days."
//         },
//         {
//           question: "Will my child's speech improve after surgery?",
//           answer: "Yes, if enlarged adenoids were causing nasal speech, improvement is typically seen within weeks after surgery as nasal airflow normalizes."
//         },
//         {
//           question: "Can adenoids grow back after surgery?",
//           answer: "Rarely, adenoid tissue can regrow, but this is uncommon. If it occurs, symptoms may return and further evaluation may be needed."
//         },
//         {
//           question: "How long is recovery after adenoidectomy?",
//           answer: "Most children recover within 1-2 weeks. Pain is usually mild and managed with over-the-counter medications. Normal activities can typically resume within a week."
//         }
//       ]
//     },

//     'tonsils': {
//       title: "Tonsillitis",
//       category: "Throat Infection",
//       tagline: "Complete Tonsillitis Treatment & Care",
//       heroImage: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1200&q=90",
//       icon: "🤒",
//       color: "#62B6CB",
//       duration: "1-2 Weeks Acute",
      
//       overview: "Tonsillitis is inflammation of the tonsils caused by viral or bacterial infection. We provide expert diagnosis and treatment including antibiotics, pain management, and surgical options for recurrent cases.",
      
//       whatIsIt: "Tonsillitis is an infection and inflammation of the tonsils - two oval-shaped pads of tissue at the back of the throat. It's most common in children but can occur at any age.",
      
//       symptoms: [
//         {
//           name: "Sore Throat",
//           description: "Severe throat pain, especially when swallowing"
//         },
//         {
//           name: "Swollen Tonsils",
//           description: "Red, swollen tonsils with white or yellow coating"
//         },
//         {
//           name: "Difficulty Swallowing",
//           description: "Painful swallowing of food or liquids"
//         },
//         {
//           name: "Fever",
//           description: "High temperature above 100.4°F (38°C)"
//         },
//         {
//           name: "Swollen Lymph Nodes",
//           description: "Tender, enlarged lymph nodes in neck"
//         },
//         {
//           name: "Bad Breath",
//           description: "Persistent foul breath (halitosis)"
//         }
//       ],
      
//       causes: [
//         "Viral infections (most common)",
//         "Streptococcus bacteria (strep throat)",
//         "Other bacterial infections",
//         "Weakened immune system",
//         "Exposure to infected individuals",
//         "Poor hygiene practices"
//       ],
      
//       treatments: [
//         {
//           title: "Antibiotics",
//           description: "For bacterial tonsillitis, typically 10-day course of penicillin or alternatives"
//         },
//         {
//           title: "Pain Relief",
//           description: "Over-the-counter pain relievers and throat lozenges"
//         },
//         {
//           title: "Rest and Hydration",
//           description: "Plenty of rest and fluids to aid recovery"
//         },
//         {
//           title: "Tonsillectomy",
//           description: "Surgical removal for recurrent tonsillitis (7+ episodes per year)"
//         },
//         {
//           title: "Corticosteroids",
//           description: "To reduce severe inflammation when needed"
//         },
//         {
//           title: "Supportive Care",
//           description: "Warm saltwater gargles, humidifier use, soft foods"
//         }
//       ],
      
//       diagnosis: [
//         "Physical examination of throat",
//         "Rapid strep test",
//         "Throat culture",
//         "Complete blood count (CBC)",
//         "Monospot test if mononucleosis suspected",
//         "Medical history review"
//       ],
      
//       prevention: [
//         "Wash hands frequently",
//         "Avoid sharing utensils or drinks",
//         "Replace toothbrush after diagnosis",
//         "Avoid close contact with sick individuals",
//         "Maintain strong immune system",
//         "Practice good oral hygiene"
//       ],
      
//       faqs: [
//         {
//           question: "Is tonsillitis contagious?",
//           answer: "Yes, both viral and bacterial tonsillitis are contagious. The infection spreads through respiratory droplets from coughing or sneezing. Practice good hygiene to prevent transmission."
//         },
//         {
//           question: "When should tonsils be removed?",
//           answer: "Tonsillectomy is considered for recurrent tonsillitis (7+ episodes in one year, 5+ for two years, or 3+ for three years), sleep-disordered breathing, or abscess formation."
//         },
//         {
//           question: "Can adults get tonsillitis?",
//           answer: "Yes, although more common in children, adults can develop tonsillitis. Adult cases may be more severe and take longer to recover."
//         },
//         {
//           question: "How long is tonsillitis contagious?",
//           answer: "Viral tonsillitis is contagious throughout the illness. Bacterial tonsillitis is contagious until 24 hours after starting antibiotics."
//         },
//         {
//           question: "What's the difference between tonsillitis and strep throat?",
//           answer: "Strep throat is bacterial tonsillitis specifically caused by Streptococcus bacteria. Tonsillitis can be viral or bacterial. Strep throat requires antibiotics."
//         }
//       ]
//     },

//     'sinusitis': {
//       title: "Sinusitis",
//       category: "Sinus Inflammation",
//       tagline: "Advanced Sinusitis Treatment & Care",
//       heroImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=90",
//       icon: "👃",
//       color: "#2C5F7C",
//       duration: "2-12 Weeks",
      
//       overview: "Sinusitis is inflammation of the sinuses causing facial pain, nasal congestion, and discharge. Our comprehensive treatment approach includes advanced diagnostics, medical therapy, and endoscopic surgery when needed for chronic cases.",
      
//       whatIsIt: "Sinusitis is inflammation or swelling of the tissue lining the sinuses. It can be acute (lasting less than 4 weeks), subacute (4-12 weeks), chronic (lasting more than 12 weeks), or recurrent (several episodes within a year).",
      
//       symptoms: [
//         {
//           name: "Facial Pain & Pressure",
//           description: "Pain and pressure around eyes, cheeks, nose, or forehead"
//         },
//         {
//           name: "Nasal Congestion",
//           description: "Stuffy nose and difficulty breathing through nose"
//         },
//         {
//           name: "Thick Nasal Discharge",
//           description: "Yellow or greenish discharge from nose or down throat"
//         },
//         {
//           name: "Reduced Sense of Smell",
//           description: "Decreased ability to smell and taste"
//         },
//         {
//           name: "Headache",
//           description: "Pain in forehead, temples, or behind eyes"
//         },
//         {
//           name: "Post-Nasal Drip",
//           description: "Mucus draining down the back of throat"
//         }
//       ],
      
//       causes: [
//         "Viral infections (common cold)",
//         "Bacterial infections",
//         "Nasal polyps or deviated septum",
//         "Allergies and hay fever",
//         "Air pollution and irritants",
//         "Weakened immune system"
//       ],
      
//       treatments: [
//         {
//           title: "Antibiotics",
//           description: "For bacterial sinusitis to eliminate infection and reduce inflammation"
//         },
//         {
//           title: "Nasal Corticosteroid Sprays",
//           description: "To reduce inflammation and improve drainage"
//         },
//         {
//           title: "Saline Irrigation",
//           description: "Nasal rinses to flush out mucus and moisturize passages"
//         },
//         {
//           title: "Decongestants",
//           description: "Short-term use to relieve nasal congestion"
//         },
//         {
//           title: "Endoscopic Sinus Surgery",
//           description: "For chronic sinusitis not responding to medical treatment"
//         },
//         {
//           title: "Steam Inhalation",
//           description: "To loosen mucus and relieve congestion"
//         }
//       ],
      
//       diagnosis: [
//         "Physical examination of nose and throat",
//         "Nasal endoscopy",
//         "CT scan of sinuses",
//         "Allergy testing",
//         "Nasal and sinus cultures",
//         "Biopsy (if needed)"
//       ],
      
//       prevention: [
//         "Practice good hand hygiene",
//         "Avoid known allergens",
//         "Use a humidifier",
//         "Stay hydrated",
//         "Avoid cigarette smoke",
//         "Manage allergies effectively"
//       ],
      
//       faqs: [
//         {
//           question: "How long does sinusitis last?",
//           answer: "Acute sinusitis typically lasts 2-4 weeks. Chronic sinusitis persists for 12 weeks or longer. With proper care, most acute cases resolve within 10 days."
//         },
//         {
//           question: "Is sinusitis contagious?",
//           answer: "Sinusitis itself is not contagious, but the viruses that can lead to sinusitis are contagious. Bacterial sinusitis is generally not contagious."
//         },
//         {
//           question: "When should I see a doctor?",
//           answer: "See a doctor if symptoms last more than 10 days, you have high fever, severe headache, vision changes, or symptoms worsen after initial improvement."
//         },
//         {
//           question: "Can I prevent recurrent sinusitis?",
//           answer: "Yes, by managing allergies, avoiding irritants, practicing good hygiene, staying hydrated, and treating underlying conditions."
//         },
//         {
//           question: "Do I need surgery for sinusitis?",
//           answer: "Surgery is typically considered only when conservative treatments fail and chronic sinusitis significantly affects quality of life."
//         }
//       ]
//     },

//     'copd': {
//       title: "COPD",
//       category: "Chronic Obstructive Pulmonary Disease",
//       tagline: "Comprehensive COPD Management",
//       heroImage: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=1200&q=90",
//       icon: "🫁",
//       color: "#E63946",
//       duration: "Chronic Condition",
      
//       overview: "COPD is a progressive lung disease making breathing difficult. Our specialized program provides medication management, pulmonary rehabilitation, oxygen therapy, and lifestyle support for better breathing and quality of life.",
      
//       whatIsIt: "COPD is a chronic inflammatory lung disease causing obstructed airflow from lungs. It includes emphysema and chronic bronchitis, typically caused by long-term exposure to irritating gases, most often from cigarette smoke.",
      
//       symptoms: [
//         {
//           name: "Chronic Cough",
//           description: "Persistent cough producing mucus, especially in morning"
//         },
//         {
//           name: "Shortness of Breath",
//           description: "Breathlessness, especially during physical activities"
//         },
//         {
//           name: "Wheezing",
//           description: "Whistling sound when breathing"
//         },
//         {
//           name: "Chest Tightness",
//           description: "Feeling of pressure or squeezing in chest"
//         },
//         {
//           name: "Frequent Infections",
//           description: "Increased susceptibility to colds, flu, and pneumonia"
//         },
//         {
//           name: "Fatigue",
//           description: "Lack of energy and constant tiredness"
//         }
//       ],
      
//       causes: [
//         "Cigarette smoking (primary cause)",
//         "Long-term exposure to secondhand smoke",
//         "Occupational dust and chemicals",
//         "Indoor air pollution from cooking and heating",
//         "Alpha-1 antitrypsin deficiency (genetic)",
//         "Chronic asthma in some cases"
//       ],
      
//       treatments: [
//         {
//           title: "Bronchodilators",
//           description: "Short and long-acting inhalers to relax airway muscles"
//         },
//         {
//           title: "Inhaled Corticosteroids",
//           description: "Anti-inflammatory medications to reduce airway inflammation"
//         },
//         {
//           title: "Oxygen Therapy",
//           description: "Supplemental oxygen for severe COPD to maintain blood oxygen"
//         },
//         {
//           title: "Pulmonary Rehabilitation",
//           description: "Exercise training, education, and support for well-being"
//         },
//         {
//           title: "Antibiotics & Antivirals",
//           description: "Treatment for respiratory infections worsening COPD"
//         },
//         {
//           title: "Surgery",
//           description: "Lung volume reduction surgery or transplant for severe cases"
//         }
//       ],
      
//       diagnosis: [
//         "Spirometry to measure lung function",
//         "Chest X-ray or CT scan",
//         "Arterial blood gas analysis",
//         "Lab tests to rule out other conditions",
//         "Alpha-1 antitrypsin screening",
//         "Regular symptom and lung function monitoring"
//       ],
      
//       prevention: [
//         "Quit smoking immediately (most important)",
//         "Avoid secondhand smoke and pollutants",
//         "Get annual flu and pneumonia vaccines",
//         "Maintain healthy weight",
//         "Exercise regularly as tolerated",
//         "Use protective equipment for occupational exposures"
//       ],
      
//       faqs: [
//         {
//           question: "Can COPD be reversed?",
//           answer: "COPD damage cannot be reversed, but symptoms can be managed and progression slowed with proper treatment, especially if you quit smoking early."
//         },
//         {
//           question: "How long can you live with COPD?",
//           answer: "Life expectancy varies greatly depending on severity, age, smoking status, and overall health. Many with mild to moderate COPD live 10-20+ years after diagnosis."
//         },
//         {
//           question: "Should I continue exercising with COPD?",
//           answer: "Yes, regular exercise is crucial. Pulmonary rehabilitation programs teach you how to exercise safely and effectively."
//         },
//         {
//           question: "When will I need oxygen therapy?",
//           answer: "Oxygen therapy is prescribed when blood oxygen levels are consistently too low (typically below 88-92%). Regular monitoring determines when it's needed."
//         },
//         {
//           question: "What are COPD exacerbations?",
//           answer: "Exacerbations are flare-ups where symptoms suddenly worsen. They can be triggered by infections or pollution. Prompt treatment is essential."
//         }
//       ]
//     },

//     'ild': {
//       title: "ILD (Interstitial Lung Disease)",
//       category: "Lung Tissue Disorders",
//       tagline: "Advanced ILD Diagnosis & Management",
//       heroImage: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=90",
//       icon: "🫁",
//       color: "#457B9D",
//       duration: "Chronic Management",
      
//       overview: "ILD encompasses disorders causing progressive lung scarring. We provide advanced diagnosis through HRCT, lung biopsy, immunosuppressive therapy, and oxygen support for improved quality of life.",
      
//       whatIsIt: "Interstitial lung disease describes a large group of disorders causing progressive scarring (fibrosis) of lung tissue. This scarring affects ability to breathe and get oxygen to bloodstream.",
      
//       symptoms: [
//         {
//           name: "Progressive Dyspnea",
//           description: "Gradually worsening shortness of breath with activity"
//         },
//         {
//           name: "Dry Cough",
//           description: "Persistent non-productive cough"
//         },
//         {
//           name: "Fatigue",
//           description: "Constant tiredness and weakness"
//         },
//         {
//           name: "Weight Loss",
//           description: "Unintentional weight loss"
//         },
//         {
//           name: "Clubbing",
//           description: "Widening and rounding of fingertips"
//         },
//         {
//           name: "Chest Discomfort",
//           description: "Aching or discomfort in chest"
//         }
//       ],
      
//       causes: [
//         "Occupational exposures (asbestos, silica)",
//         "Autoimmune diseases",
//         "Medications and treatments",
//         "Radiation therapy",
//         "Environmental factors",
//         "Idiopathic (unknown cause)"
//       ],
      
//       treatments: [
//         {
//           title: "Immunosuppressants",
//           description: "Corticosteroids and other drugs to reduce inflammation"
//         },
//         {
//           title: "Antifibrotic Agents",
//           description: "Medications to slow lung scarring progression"
//         },
//         {
//           title: "Oxygen Therapy",
//           description: "Supplemental oxygen to maintain adequate blood oxygen"
//         },
//         {
//           title: "Pulmonary Rehabilitation",
//           description: "Exercise and education program to improve function"
//         },
//         {
//           title: "Lung Transplant Evaluation",
//           description: "Assessment for transplant candidacy in advanced cases"
//         },
//         {
//           title: "Supportive Care",
//           description: "Managing symptoms and preventing complications"
//         }
//       ],
      
//       diagnosis: [
//         "High-resolution CT (HRCT) scan",
//         "Pulmonary function tests",
//         "Arterial blood gas analysis",
//         "Bronchoscopy with biopsy",
//         "Surgical lung biopsy if needed",
//         "Blood tests for autoimmune markers"
//       ],
      
//       prevention: [
//         "Avoid occupational exposures",
//         "Don't smoke",
//         "Protect against environmental hazards",
//         "Regular health screenings if at risk",
//         "Manage underlying autoimmune conditions",
//         "Follow medication guidelines carefully"
//       ],
      
//       faqs: [
//         {
//           question: "Is ILD curable?",
//           answer: "Most ILD types cannot be cured, but progression can be slowed with proper treatment. Some cases caused by medications may improve when the drug is stopped."
//         },
//         {
//           question: "How fast does ILD progress?",
//           answer: "Progression varies widely depending on ILD type and individual factors. Some progress slowly over years, while others advance more rapidly."
//         },
//         {
//           question: "Will I need oxygen therapy?",
//           answer: "Many people with ILD eventually need supplemental oxygen, especially during activity or sleep. Your doctor monitors oxygen levels to determine when it's needed."
//         },
//         {
//           question: "Can I exercise with ILD?",
//           answer: "Yes, exercise is encouraged. Pulmonary rehabilitation helps you exercise safely while managing symptoms. Start slowly and gradually increase activity."
//         },
//         {
//           question: "What's the life expectancy with ILD?",
//           answer: "Life expectancy varies greatly depending on ILD type, severity, and response to treatment. Some people live many years with proper management."
//         }
//       ]
//     },

//     'obesity': {
//       title: "Obesity & Metabolic Disorders",
//       category: "Weight Management",
//       tagline: "Comprehensive Weight Management Program",
//       heroImage: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200&q=90",
//       icon: "⚖️",
//       color: "#FF9B6E",
//       duration: "Ongoing Program",
      
//       overview: "Obesity affects breathing and overall health. Our comprehensive program includes dietary counseling, exercise plans, medical therapy, and surgical referrals when appropriate for sustainable weight management.",
      
//       whatIsIt: "Obesity is a complex disease involving excessive body fat that increases risk of health problems. It affects breathing, causes sleep apnea, and contributes to numerous metabolic disorders.",
      
//       symptoms: [
//         {
//           name: "Excess Weight",
//           description: "BMI of 30 or higher"
//         },
//         {
//           name: "Breathing Difficulties",
//           description: "Shortness of breath with minimal exertion"
//         },
//         {
//           name: "Sleep Apnea",
//           description: "Interrupted breathing during sleep"
//         },
//         {
//           name: "Joint Pain",
//           description: "Pain in knees, hips, and back"
//         },
//         {
//           name: "Fatigue",
//           description: "Low energy and constant tiredness"
//         },
//         {
//           name: "Sweating",
//           description: "Excessive sweating even with light activity"
//         }
//       ],
      
//       causes: [
//         "Poor diet and eating habits",
//         "Physical inactivity",
//         "Genetics and family history",
//         "Medical conditions and medications",
//         "Psychological factors",
//         "Lack of sleep"
//       ],
      
//       treatments: [
//         {
//           title: "Dietary Counseling",
//           description: "Personalized nutrition plans with registered dietitian"
//         },
//         {
//           title: "Exercise Programs",
//           description: "Structured physical activity plans tailored to fitness level"
//         },
//         {
//           title: "Behavioral Therapy",
//           description: "Addressing emotional and psychological aspects of eating"
//         },
//         {
//           title: "Medical Therapy",
//           description: "Weight loss medications when appropriate"
//         },
//         {
//           title: "Bariatric Surgery Referral",
//           description: "Surgical options for severe obesity when other methods fail"
//         },
//         {
//           title: "Support Groups",
//           description: "Peer support and accountability for sustained success"
//         }
//       ],
      
//       diagnosis: [
//         "BMI calculation",
//         "Waist circumference measurement",
//         "Body composition analysis",
//         "Blood tests (cholesterol, glucose, thyroid)",
//         "Sleep study if apnea suspected",
//         "Assessment of related health conditions"
//       ],
      
//       prevention: [
//         "Maintain balanced, healthy diet",
//         "Regular physical activity (150 min/week)",
//         "Adequate sleep (7-9 hours)",
//         "Stress management",
//         "Avoid processed and high-calorie foods",
//         "Regular health check-ups"
//       ],
      
//       faqs: [
//         {
//           question: "How much weight should I aim to lose?",
//           answer: "Even a 5-10% weight loss can significantly improve health. Set realistic goals with your healthcare team - typically 1-2 pounds per week is healthy."
//         },
//         {
//           question: "Will I regain weight after losing it?",
//           answer: "Weight maintenance requires ongoing effort. Long-term success comes from sustainable lifestyle changes, not quick fixes. Regular follow-up and support help prevent regain."
//         },
//         {
//           question: "Are weight loss medications safe?",
//           answer: "FDA-approved weight loss medications are safe when used under medical supervision. They work best combined with diet and exercise, not as standalone treatment."
//         },
//         {
//           question: "When is bariatric surgery considered?",
//           answer: "Surgery is considered for BMI ≥40 or BMI ≥35 with obesity-related health problems when other weight loss methods haven't worked."
//         },
//         {
//           question: "Can obesity affect my breathing?",
//           answer: "Yes, excess weight restricts lung expansion, increases breathing effort, and commonly causes sleep apnea. Weight loss significantly improves respiratory function."
//         }
//       ]
//     },

//     'tb': {
//       title: "Tuberculosis (TB)",
//       category: "Bacterial Infection",
//       tagline: "Complete TB Diagnosis & Treatment",
//       heroImage: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=1200&q=90",
//       icon: "🦠",
//       color: "#E86A33",
//       duration: "6-9 Months Treatment",
      
//       overview: "TB is a serious bacterial infection primarily affecting lungs. Our comprehensive program provides accurate diagnosis, complete DOTS therapy, regular monitoring, and contact tracing to ensure cure and prevent spread.",
      
//       whatIsIt: "Tuberculosis is caused by Mycobacterium tuberculosis bacteria. It spreads through air when infected person coughs or sneezes. TB can be latent (inactive) or active (symptomatic and contagious).",
      
//       symptoms: [
//         {
//           name: "Persistent Cough",
//           description: "Cough lasting more than 3 weeks, may produce blood"
//         },
//         {
//           name: "Chest Pain",
//           description: "Pain in chest, especially when breathing or coughing"
//         },
//         {
//           name: "Fever & Night Sweats",
//           description: "Low-grade fever and excessive night sweating"
//         },
//         {
//           name: "Weight Loss",
//           description: "Significant unintentional weight loss"
//         },
//         {
//           name: "Loss of Appetite",
//           description: "Decreased desire to eat"
//         },
//         {
//           name: "Fatigue",
//           description: "Constant tiredness and weakness"
//         }
//       ],
      
//       causes: [
//         "Inhalation of TB bacteria from infected person",
//         "Weakened immune system (HIV, diabetes)",
//         "Close contact with TB patients",
//         "Living in crowded conditions",
//         "Malnutrition and poverty",
//         "Healthcare worker exposure"
//       ],
      
//       treatments: [
//         {
//           title: "DOTS Therapy",
//           description: "Directly Observed Treatment Short-course with supervision"
//         },
//         {
//           title: "First-Line Drugs",
//           description: "Combination of isoniazid, rifampicin, ethambutol, pyrazinamide"
//         },
//         {
//           title: "Second-Line Drugs",
//           description: "For drug-resistant TB, requiring 18-24 months"
//         },
//         {
//           title: "Regular Monitoring",
//           description: "Monthly check-ups, sputum tests, liver function monitoring"
//         },
//         {
//           title: "Contact Tracing",
//           description: "Screening family members and close contacts"
//         },
//         {
//           title: "Preventive Therapy",
//           description: "Treatment for latent TB to prevent active disease"
//         }
//       ],
      
//       diagnosis: [
//         "Tuberculin skin test (TST)",
//         "Interferon-gamma release assays (IGRAs)",
//         "Chest X-ray",
//         "Sputum smear microscopy",
//         "GeneXpert MTB/RIF test",
//         "TB culture (gold standard)"
//       ],
      
//       prevention: [
//         "BCG vaccination in endemic areas",
//         "Avoid close contact with active TB cases",
//         "Ensure good ventilation in living spaces",
//         "Practice good hygiene and cough etiquette",
//         "Strengthen immune system with healthy diet",
//         "Complete preventive therapy if exposed"
//       ],
      
//       faqs: [
//         {
//           question: "Is TB curable?",
//           answer: "Yes, TB is completely curable with proper treatment. You must take all medications exactly as prescribed for the full 6-9 months, even when feeling better."
//         },
//         {
//           question: "How long am I contagious?",
//           answer: "Most people become non-contagious within 2-3 weeks of starting proper treatment. Continue isolation as directed until tests confirm you're not infectious."
//         },
//         {
//           question: "Can I get TB more than once?",
//           answer: "Yes, you can get TB again after being cured, especially if exposed to someone with active TB and have weakened immunity."
//         },
//         {
//           question: "What are TB medication side effects?",
//           answer: "Common effects include nausea, loss of appetite, urine discoloration. Serious effects include liver problems and vision changes. Regular monitoring helps."
//         },
//         {
//           question: "Do I need to isolate during treatment?",
//           answer: "Initially yes, especially with pulmonary TB. Once on treatment and no longer contagious (usually 2-3 weeks), resume normal activities but complete full treatment."
//         }
//       ]
//     },

//     'lung-cancer': {
//       title: "Lung Cancer",
//       category: "Malignant Lung Growth",
//       tagline: "Comprehensive Lung Cancer Care",
//       heroImage: "https://images.unsplash.com/photo-1579684453423-f84349ef60b0?w=1200&q=90",
//       icon: "🎗️",
//       color: "#A8DADC",
//       duration: "Varies by Stage",
      
//       overview: "Lung cancer is a serious condition requiring prompt diagnosis and treatment. We provide early detection, comprehensive cancer care through bronchoscopy, biopsy, chemotherapy, radiation, and palliative care.",
      
//       whatIsIt: "Lung cancer is uncontrolled growth of abnormal cells in one or both lungs. These cells can form tumors and interfere with lung function. It's the leading cause of cancer deaths worldwide.",
      
//       symptoms: [
//         {
//           name: "Persistent Cough",
//           description: "Cough that doesn't go away or worsens over time"
//         },
//         {
//           name: "Hemoptysis",
//           description: "Coughing up blood or rust-colored sputum"
//         },
//         {
//           name: "Chest Pain",
//           description: "Persistent pain that worsens with breathing or laughing"
//         },
//         {
//           name: "Shortness of Breath",
//           description: "Unexplained breathlessness or wheezing"
//         },
//         {
//           name: "Weight Loss",
//           description: "Unintentional significant weight loss"
//         },
//         {
//           name: "Hoarseness",
//           description: "Voice changes or persistent hoarseness"
//         }
//       ],
      
//       causes: [
//         "Cigarette smoking (primary cause - 80-90%)",
//         "Secondhand smoke exposure",
//         "Radon gas exposure",
//         "Occupational exposures (asbestos, arsenic)",
//         "Air pollution",
//         "Family history of lung cancer"
//       ],
      
//       treatments: [
//         {
//           title: "Surgery",
//           description: "Surgical removal of tumor and surrounding tissue"
//         },
//         {
//           title: "Chemotherapy",
//           description: "Drugs to kill cancer cells throughout body"
//         },
//         {
//           title: "Radiation Therapy",
//           description: "High-energy beams to destroy cancer cells"
//         },
//         {
//           title: "Targeted Therapy",
//           description: "Drugs targeting specific cancer cell abnormalities"
//         },
//         {
//           title: "Immunotherapy",
//           description: "Helping immune system fight cancer"
//         },
//         {
//           title: "Palliative Care",
//           description: "Managing symptoms and improving quality of life"
//         }
//       ],
      
//       diagnosis: [
//         "Chest X-ray",
//         "CT scan",
//         "PET scan",
//         "Bronchoscopy with biopsy",
//         "Sputum cytology",
//         "Molecular testing of tumor"
//       ],
      
//       prevention: [
//         "Don't smoke or quit smoking immediately",
//         "Avoid secondhand smoke",
//         "Test home for radon",
//         "Avoid carcinogens at work",
//         "Eat diet rich in fruits and vegetables",
//         "Exercise regularly"
//       ],
      
//       faqs: [
//         {
//           question: "What is the survival rate for lung cancer?",
//           answer: "Survival rates vary greatly by stage at diagnosis. Early-stage lung cancer (stage 1) has much better prognosis than advanced stages. Early detection is crucial."
//         },
//         {
//           question: "Can non-smokers get lung cancer?",
//           answer: "Yes, about 10-20% of lung cancers occur in people who never smoked. Causes include secondhand smoke, radon, air pollution, and genetic factors."
//         },
//         {
//           question: "Is lung cancer screening recommended?",
//           answer: "Yes, annual low-dose CT screening is recommended for high-risk individuals aged 50-80 with significant smoking history."
//         },
//         {
//           question: "How is lung cancer staged?",
//           answer: "Lung cancer is staged from 0 to 4 based on tumor size, lymph node involvement, and spread to other organs. Staging guides treatment decisions."
//         },
//         {
//           question: "Can lung cancer be cured?",
//           answer: "Early-stage lung cancer can often be cured with surgery. Advanced stages may not be curable but can be treated to extend life and improve quality."
//         }
//       ]
//     }
//   };

//   const procedure = proceduresData[procedureId];

//   if (!procedure) {
//     return (
//       <div style={{padding: '4rem 2rem', textAlign: 'center', minHeight: '100vh'}}>
//         <h2>Procedure not found</h2>
//         <Link to="/procedures" style={{color: '#E86A33'}}>Back to Procedures</Link>
//       </div>
//     );
//   }

//   const toggleFAQ = (index) => {
//     setOpenFAQ(openFAQ === index ? null : index);
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           color: #1a1a1a;
//         }

//         .procedure-detail-redesigned {
//           width: 100%;
//           min-height: 100vh;
//           background: #FAFBFC;
//         }

//         /* Compact Hero Section */
//         .procedure-hero-compact {
//           position: relative;
//           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
//           padding: 3rem 2rem 2rem;
//         }

//         .procedure-hero-compact::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           right: 0;
//           width: 50%;
//           height: 100%;
//           background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="rgba(232,106,51,0.1)"/></svg>');
//           background-size: 60px;
//           opacity: 0.3;
//         }

//         .hero-content-compact {
//           max-width: 1400px;
//           margin: 0 auto;
//           position: relative;
//           z-index: 2;
//         }

//         .back-link-compact {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 600;
//           margin-bottom: 2rem;
//           padding: 0.6rem 1.2rem;
//           background: rgba(255, 255, 255, 0.15);
//           backdrop-filter: blur(10px);
//           border-radius: 50px;
//           font-size: 0.9rem;
//           transition: all 0.3s ease;
//         }

//         .back-link-compact:hover {
//           background: rgba(255, 255, 255, 0.25);
//           transform: translateX(-5px);
//         }

//         .hero-grid {
//           display: grid;
//           grid-template-columns: auto 1fr auto;
//           gap: 2rem;
//           align-items: center;
//         }

//         .hero-icon-box {
//           width: 100px;
//           height: 100px;
//           background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
//           backdrop-filter: blur(20px);
//           border-radius: 25px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 3.5rem;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//         }

//         .hero-text {
//           color: white;
//         }

//         .category-tag {
//           display: inline-block;
//           padding: 0.4rem 1rem;
//           background: rgba(232, 106, 51, 0.2);
//           border-radius: 50px;
//           font-size: 0.8rem;
//           font-weight: 700;
//           text-transform: uppercase;
//           letter-spacing: 1px;
//           margin-bottom: 0.8rem;
//           color: #FFD700;
//         }

//         .hero-title-compact {
//           font-family: 'Playfair Display', serif;
//           font-size: 2.8rem;
//           font-weight: 800;
//           margin-bottom: 0.5rem;
//           line-height: 1.2;
//         }

//         .hero-subtitle {
//           font-size: 1.1rem;
//           opacity: 0.9;
//           font-weight: 400;
//         }

//         .hero-meta {
//           display: flex;
//           flex-direction: column;
//           gap: 0.8rem;
//           padding: 1.5rem;
//           background: rgba(255, 255, 255, 0.15);
//           backdrop-filter: blur(20px);
//           border-radius: 20px;
//           border: 2px solid rgba(255, 255, 255, 0.2);
//         }

//         .meta-item-hero {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           color: white;
//           font-size: 0.95rem;
//           font-weight: 600;
//         }

//         /* Contact Strip */
//         .contact-strip {
//           background: white;
//           border-bottom: 3px solid #E86A33;
//           padding: 1.2rem 2rem;
//           box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
//         }

//         .contact-strip-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         .contact-items {
//           display: flex;
//           gap: 2.5rem;
//           flex-wrap: wrap;
//         }

//         .contact-item-strip {
//           display: flex;
//           align-items: center;
//           gap: 0.8rem;
//           color: #1B4965;
//           font-weight: 600;
//           font-size: 0.95rem;
//         }

//         .contact-icon {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//         }

//         .contact-item-strip a {
//           color: #1B4965;
//           text-decoration: none;
//           transition: color 0.3s ease;
//         }

//         .contact-item-strip a:hover {
//           color: #E86A33;
//         }

//         .book-btn-strip {
//           padding: 0.9rem 2.5rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//           text-decoration: none;
//         }

//         .book-btn-strip:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         /* Main Content - Full Width with Sidebar */
//         .procedure-main {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 3rem 2rem;
//           display: grid;
//           grid-template-columns: 3fr 1fr;
//           gap: 3rem;
//         }

//         /* Overview Card - Full Width */
//         .overview-card {
//           background: white;
//           border-radius: 20px;
//           padding: 3rem;
//           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
//           margin-bottom: 2rem;
//           border-left: 5px solid #2C85B8;
//         }

//         .overview-title {
//           font-size: 2rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .overview-text {
//           font-size: 1.05rem;
//           line-height: 1.9;
//           color: #444;
//           margin-bottom: 1.5rem;
//         }

//         /* Tabbed Interface */
//         .tabs-container {
//           background: white;
//           border-radius: 20px;
//           overflow: hidden;
//           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
//           margin-bottom: 2rem;
//         }

//         .tabs-header {
//           display: flex;
//           background: #F8FAFB;
//           border-bottom: 2px solid #E5E7EB;
//         }

//         .tab-button {
//           flex: 1;
//           padding: 1.2rem 1.5rem;
//           background: transparent;
//           border: none;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           color: #666;
//           position: relative;
//         }

//         .tab-button.active {
//           color: #E86A33;
//           background: white;
//         }

//         .tab-button.active::after {
//           content: '';
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           height: 3px;
//           background: linear-gradient(90deg, #E86A33, #FF9B6E);
//         }

//         .tab-button:hover:not(.active) {
//           color: #1B4965;
//           background: rgba(232, 106, 51, 0.05);
//         }

//         .tab-content {
//           padding: 2.5rem;
//         }

//         /* Symptoms as Cards */
//         .symptoms-cards {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1.2rem;
//         }

//         .symptom-card-new {
//           padding: 1.5rem;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//           border-radius: 15px;
//           border: 2px solid #E5E7EB;
//           transition: all 0.3s ease;
//           position: relative;
//           overflow: hidden;
//         }

//         .symptom-card-new::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 4px;
//           height: 0;
//           background: linear-gradient(to bottom, #E86A33, #FF9B6E);
//           transition: height 0.3s ease;
//         }

//         .symptom-card-new:hover {
//           border-color: #E86A33;
//           transform: translateY(-3px);
//           box-shadow: 0 8px 25px rgba(232, 106, 51, 0.15);
//         }

//         .symptom-card-new:hover::before {
//           height: 100%;
//         }

//         .symptom-name-new {
//           font-size: 1.1rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 0.6rem;
//           display: flex;
//           align-items: center;
//           gap: 0.6rem;
//         }

//         .symptom-desc-new {
//           font-size: 0.95rem;
//           line-height: 1.6;
//           color: #666;
//         }

//         /* Treatments as Timeline */
//         .treatment-timeline {
//           position: relative;
//           padding-left: 2rem;
//         }

//         .treatment-timeline::before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 0;
//           bottom: 0;
//           width: 3px;
//           background: linear-gradient(to bottom, #2C85B8, #62B6CB);
//         }

//         .treatment-item {
//           position: relative;
//           margin-bottom: 2rem;
//           padding-left: 2rem;
//         }

//         .treatment-item::before {
//           content: '';
//           position: absolute;
//           left: -2.5rem;
//           top: 0.5rem;
//           width: 18px;
//           height: 18px;
//           background: white;
//           border: 4px solid #2C85B8;
//           border-radius: 50%;
//           box-shadow: 0 0 0 4px rgba(44, 133, 184, 0.1);
//         }

//         .treatment-title-new {
//           font-size: 1.2rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 0.5rem;
//         }

//         .treatment-desc-new {
//           font-size: 1rem;
//           line-height: 1.7;
//           color: #666;
//         }

//         /* Simple Lists with Icons */
//         .icon-list {
//           display: grid;
//           gap: 1rem;
//         }

//         .icon-list-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 1rem;
//           padding: 1rem 1.2rem;
//           background: #F8FAFB;
//           border-radius: 12px;
//           transition: all 0.3s ease;
//         }

//         .icon-list-item:hover {
//           background: white;
//           box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
//           transform: translateX(8px);
//         }

//         .list-icon-new {
//           width: 24px;
//           height: 24px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           flex-shrink: 0;
//           margin-top: 0.1rem;
//         }

//         /* FAQ Redesigned */
//         .faq-section {
//           margin-top: 2rem;
//         }

//         .faq-item-new {
//           background: white;
//           border: 2px solid #E5E7EB;
//           border-radius: 15px;
//           margin-bottom: 1rem;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }

//         .faq-item-new.open {
//           border-color: #2C85B8;
//           box-shadow: 0 4px 20px rgba(44, 133, 184, 0.1);
//         }

//         .faq-question-new {
//           padding: 1.5rem 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.05rem;
//           color: #1B4965;
//           transition: all 0.3s ease;
//           background: #F8FAFB;
//         }

//         .faq-item-new.open .faq-question-new {
//           background: white;
//           color: #2C85B8;
//         }

//         .faq-answer-new {
//           padding: 0 2rem 1.5rem;
//           font-size: 1rem;
//           line-height: 1.8;
//           color: #666;
//         }

//         /* Sidebar - Info Cards */
//         .sidebar-new {
//           display: flex;
//           flex-direction: column;
//           gap: 1.5rem;
//         }

//         .info-card {
//           background: white;
//           border-radius: 20px;
//           padding: 2rem;
//           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
//           border-top: 4px solid #2C85B8;
//         }

//         .info-card-title {
//           font-size: 1.3rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .info-row {
//           display: flex;
//           justify-content: space-between;
//           padding: 1rem 0;
//           border-bottom: 1px solid #F0F0F0;
//         }

//         .info-row:last-child {
//           border-bottom: none;
//         }

//         .info-label {
//           font-weight: 600;
//           color: #666;
//           font-size: 0.9rem;
//         }

//         .info-value {
//           font-weight: 700;
//           color: #1B4965;
//           text-align: right;
//         }

//         /* CTA Card */
//         .cta-card-new {
//           background: linear-gradient(135deg, #2C85B8 0%, #1B4965 100%);
//           color: white;
//           text-align: center;
//           position: relative;
//           overflow: hidden;
//         }

//         .cta-card-new::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -50%;
//           width: 200%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(232, 106, 51, 0.2) 0%, transparent 70%);
//           animation: pulse 3s ease-in-out infinite;
//         }

//         @keyframes pulse {
//           0%, 100% { transform: scale(1); opacity: 0.5; }
//           50% { transform: scale(1.1); opacity: 0.8; }
//         }

//         .cta-card-content {
//           position: relative;
//           z-index: 2;
//         }

//         .cta-title-new {
//           font-size: 1.6rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .cta-text-new {
//           font-size: 0.95rem;
//           opacity: 0.95;
//           margin-bottom: 1.5rem;
//           line-height: 1.6;
//         }

//         .cta-contacts {
//           display: flex;
//           flex-direction: column;
//           gap: 0.8rem;
//           margin-bottom: 1.5rem;
//         }

//         .cta-contact-item {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 0.8rem;
//           padding: 0.8rem;
//           background: rgba(255, 255, 255, 0.1);
//           border-radius: 12px;
//           font-weight: 600;
//           font-size: 0.9rem;
//         }

//         .cta-contact-item a {
//           color: white;
//           text-decoration: none;
//         }

//         .cta-button-new {
//           width: 100%;
//           padding: 1rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//           text-decoration: none;
//         }

//         .cta-button-new:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 20px rgba(232, 106, 51, 0.4);
//         }

//         /* Responsive */
//         @media (max-width: 1024px) {
//           .procedure-main {
//             grid-template-columns: 1fr;
//           }

//           .hero-grid {
//             grid-template-columns: 1fr;
//             text-align: center;
//           }

//           .hero-icon-box {
//             margin: 0 auto;
//           }

//           .hero-meta {
//             margin: 0 auto;
//             max-width: 300px;
//           }

//           .symptoms-cards {
//             grid-template-columns: 1fr;
//           }
//         }

//         @media (max-width: 768px) {
//           .hero-title-compact {
//             font-size: 2rem;
//           }

//           .contact-strip-content {
//             flex-direction: column;
//             align-items: flex-start;
//           }

//           .overview-card,
//           .tab-content {
//             padding: 2rem;
//           }

//           .tabs-header {
//             flex-wrap: wrap;
//           }

//           .tab-button {
//             flex: 1 1 50%;
//           }
//         }
//       `}</style>

//       <div className="procedure-detail-redesigned">
//         {/* Compact Hero */}
//         <section className="procedure-hero-compact">
//           <div className="hero-content-compact">
//             <Link to="/procedures" className="back-link-compact">
//               <ArrowLeft size={18} />
//               Back to Procedures
//             </Link>

//             <div className="hero-grid">
//               <div className="hero-icon-box">
//                 {procedure.icon}
//               </div>

//               <div className="hero-text">
//                 <div className="category-tag">{procedure.category}</div>
//                 <h1 className="hero-title-compact">{procedure.title}</h1>
//                 <p className="hero-subtitle">{procedure.tagline}</p>
//               </div>

//               <div className="hero-meta">
//                 <div className="meta-item-hero">
//                   <Clock size={20} />
//                   <span>{procedure.duration}</span>
//                 </div>
//                 <div className="meta-item-hero">
//                   <Stethoscope size={20} />
//                   <span>Expert Care</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Contact Strip */}
//         <div className="contact-strip">
//           <div className="contact-strip-content">
//             <div className="contact-items">
//               {/* <div className="contact-item-strip">
//                 <div className="contact-icon">
//                   <Phone size={18} />
//                 </div>
//                 <a href="tel:+919989162222">+91 99891 62222</a>
//               </div> */}
//               <div className="contact-item-strip">
//                 <div className="contact-icon">
//                   <Phone size={18} />
//                 </div>
//                 <a href="tel:+919989162222">+91 99891 62222</a>
//               </div>
//               <div className="contact-item-strip">
//                 <div className="contact-icon">
//                   <Mail size={18} />
//                 </div>
//                 <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
//               </div>
//             </div>
//             <a href="/contact" className="book-btn-strip">
//               <Calendar size={20} />
//               Book Appointment
//             </a>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="procedure-main">
//           <div>
//             {/* Overview */}
//             <div className="overview-card">
//               <h2 className="overview-title">Understanding {procedure.title}</h2>
//               <p className="overview-text">{procedure.overview}</p>
//               <p className="overview-text">{procedure.whatIsIt}</p>
//             </div>

//             {/* Tabbed Content */}
//             <div className="tabs-container">
//               <div className="tabs-header">
//                 <button 
//                   className={`tab-button ${activeTab === 'symptoms' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('symptoms')}
//                 >
//                   <AlertCircle size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
//                   Symptoms
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'causes' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('causes')}
//                 >
//                   <Info size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
//                   Causes
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'treatment' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('treatment')}
//                 >
//                   <Shield size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
//                   Treatment
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'prevention' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('prevention')}
//                 >
//                   <Heart size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
//                   Prevention
//                 </button>
//               </div>

//               <div className="tab-content">
//                 {/* Symptoms Tab */}
//                 {activeTab === 'symptoms' && (
//                   <div className="symptoms-cards">
//                     {procedure.symptoms.map((symptom, index) => (
//                       <div key={index} className="symptom-card-new">
//                         <div className="symptom-name-new">
//                           <AlertCircle size={18} style={{color: '#E86A33'}} />
//                           {symptom.name}
//                         </div>
//                         <div className="symptom-desc-new">{symptom.description}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Causes Tab */}
//                 {activeTab === 'causes' && (
//                   <div className="icon-list">
//                     {procedure.causes.map((cause, index) => (
//                       <div key={index} className="icon-list-item">
//                         <div className="list-icon-new">
//                           <AlertCircle size={14} />
//                         </div>
//                         <span>{cause}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Treatment Tab */}
//                 {activeTab === 'treatment' && (
//                   <div className="treatment-timeline">
//                     {procedure.treatments.map((treatment, index) => (
//                       <div key={index} className="treatment-item">
//                         <div className="treatment-title-new">{treatment.title}</div>
//                         <div className="treatment-desc-new">{treatment.description}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Prevention Tab */}
//                 {activeTab === 'prevention' && (
//                   <div className="icon-list">
//                     {procedure.prevention.map((tip, index) => (
//                       <div key={index} className="icon-list-item">
//                         <div className="list-icon-new">
//                           <CheckCircle size={14} />
//                         </div>
//                         <span>{tip}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* FAQ Section */}
//             <div className="tabs-container">
//               <div className="tabs-header">
//                 <div className="tab-button active">
//                   <BookOpen size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
//                   Frequently Asked Questions
//                 </div>
//               </div>
//               <div className="tab-content">
//                 <div className="faq-section">
//                   {procedure.faqs.map((faq, index) => (
//                     <div 
//                       key={index} 
//                       className={`faq-item-new ${openFAQ === index ? 'open' : ''}`}
//                     >
//                       <div 
//                         className="faq-question-new"
//                         onClick={() => toggleFAQ(index)}
//                       >
//                         <span>{faq.question}</span>
//                         {openFAQ === index ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
//                       </div>
//                       {openFAQ === index && (
//                         <div className="faq-answer-new">
//                           {faq.answer}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="sidebar-new">
//             {/* Quick Info */}
//             <div className="info-card">
//               <h3 className="info-card-title">Quick Information</h3>
//               <div className="info-row">
//                 <span className="info-label">Duration</span>
//                 <span className="info-value">{procedure.duration}</span>
//               </div>
//               <div className="info-row">
//                 <span className="info-label">Category</span>
//                 <span className="info-value">{procedure.category}</span>
//               </div>
//               <div className="info-row">
//                 <span className="info-label">Specialist</span>
//                 <span className="info-value">Available</span>
//               </div>
//             </div>

//             {/* CTA Card */}
//             <div className="info-card cta-card-new">
//               <div className="cta-card-content">
//                 <h3 className="cta-title-new">Need Consultation?</h3>
//                 <p className="cta-text-new">
//                   Get expert medical advice for your condition
//                 </p>
                
//                 <div className="cta-contacts">
//                   <div className="cta-contact-item">
//                     <Phone size={16} />
//                     <a href="tel:+919989162222">+91 99891 62222</a>
//                   </div>
//                   <div className="cta-contact-item">
//                     <Mail size={16} />
//                     <a href="mailto:vayulungcare@gmail.com">Email Us</a>
//                   </div>
//                 </div>

//                 <a href="/contact" className="cta-button-new">
//                   <Calendar size={20} />
//                   Schedule Now
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProcedureDetailPageRedesigned;

import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  ArrowLeft,
  AlertCircle,
  CheckCircle,
  Phone,
  Mail,
  Calendar,
  ChevronDown,
  ChevronUp,
  Info,
  Shield,
  Heart,
  Activity,
  Clock,
  Users,
  Target,
  BookOpen,
  Stethoscope
} from 'lucide-react';

const ProcedureDetailPageRedesigned = () => {
  const { procedureId } = useParams();
  const [openFAQ, setOpenFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState('symptoms');

  // Comprehensive procedure data
  // const proceduresData = {
  //   'asthma': {
  //     title: "Asthma",
  //     category: "Chronic Respiratory Condition",
  //     tagline: "Comprehensive Asthma Management & Care",
  //     heroImage: "https://images.unsplash.com/photo-1584362917165-526a968579e8?w=1200&q=90",
  //     icon: "🫁",
  //     color: "#2C85B8",
  //     duration: "Ongoing Management",
      
  //     overview: "Asthma is a chronic respiratory condition that causes inflammation and narrowing of the airways, leading to difficulty breathing. Our comprehensive asthma management program provides personalized care through accurate diagnosis, effective treatment plans, and ongoing support to help you live a full, active life.",
      
  //     whatIsIt: "Asthma is a chronic inflammatory disease of the airways characterized by variable and recurring symptoms, reversible airflow obstruction, and bronchospasm. It affects people of all ages and can range from mild to severe, potentially life-threatening cases.",
      
  //     symptoms: [
  //       {
  //         name: "Wheezing",
  //         description: "A whistling sound when breathing, especially during exhalation"
  //       },
  //       {
  //         name: "Shortness of Breath",
  //         description: "Difficulty breathing or feeling like you can't get enough air"
  //       },
  //       {
  //         name: "Chest Tightness",
  //         description: "Feeling of pressure or constriction in the chest"
  //       },
  //       {
  //         name: "Persistent Coughing",
  //         description: "Frequent coughing, especially at night or early morning"
  //       },
  //       {
  //         name: "Difficulty Sleeping",
  //         description: "Breathing problems that wake you up or prevent sleep"
  //       },
  //       {
  //         name: "Exercise Intolerance",
  //         description: "Breathing difficulties during or after physical activity"
  //       }
  //     ],
      
  //     causes: [
  //       "Genetic predisposition and family history",
  //       "Environmental allergens (pollen, dust mites, pet dander)",
  //       "Respiratory infections, especially in childhood",
  //       "Air pollution and cigarette smoke exposure",
  //       "Occupational irritants and chemicals",
  //       "Cold air, exercise, and stress triggers"
  //     ],
      
  //     treatments: [
  //       {
  //         title: "Inhaler Therapy",
  //         description: "Quick-relief and long-term control medications using inhalers and spacers for effective drug delivery"
  //       },
  //       {
  //         title: "Nebulization",
  //         description: "Medication delivered as a mist for severe symptoms or young children who can't use inhalers"
  //       },
  //       {
  //         title: "Immunotherapy",
  //         description: "Allergy shots or sublingual tablets to reduce sensitivity to specific allergens"
  //       },
  //       {
  //         title: "Oral Medications",
  //         description: "Leukotriene modifiers, theophylline, and oral steroids for severe cases"
  //       },
  //       {
  //         title: "Biologic Therapies",
  //         description: "Advanced injectable medications for severe, uncontrolled asthma"
  //       },
  //       {
  //         title: "Lifestyle Management",
  //         description: "Trigger avoidance, breathing exercises, and asthma action plan development"
  //       }
  //     ],
      
  //     diagnosis: [
  //       "Detailed medical history and physical examination",
  //       "Spirometry to measure lung function",
  //       "Peak flow monitoring",
  //       "Chest X-ray to rule out other conditions",
  //       "Allergy testing to identify triggers",
  //       "Bronchial provocation tests if needed"
  //     ],
      
  //     prevention: [
  //       "Identify and avoid asthma triggers",
  //       "Take medications as prescribed",
  //       "Monitor breathing and symptoms daily",
  //       "Get vaccinated against flu and pneumonia",
  //       "Maintain a healthy weight",
  //       "Practice breathing exercises regularly"
  //     ],
      
  //     faqs: [
  //       {
  //         question: "Can asthma be cured?",
  //         answer: "Asthma cannot be cured, but it can be effectively managed. With proper treatment and trigger avoidance, most people with asthma can live normal, active lives with minimal symptoms."
  //       },
  //       {
  //         question: "Will I need to use an inhaler forever?",
  //         answer: "Many people need long-term inhaler use to control asthma. However, some children may outgrow their asthma, and medication needs can change over time. Your doctor will regularly assess whether you can reduce or modify your treatment."
  //       },
  //       {
  //         question: "Is it safe to exercise with asthma?",
  //         answer: "Yes, with proper management. Exercise is actually beneficial for people with asthma. Use your preventer inhaler before exercise, warm up properly, and have your rescue inhaler available. Inform your doctor about exercise-induced symptoms."
  //       },
  //       {
  //         question: "What should I do during an asthma attack?",
  //         answer: "Sit upright, stay calm, take your rescue inhaler (2-4 puffs), breathe slowly and deeply. If symptoms don't improve in 5-10 minutes, repeat. Call emergency services if there's no improvement or if you experience severe symptoms."
  //       },
  //       {
  //         question: "Can asthma get worse over time?",
  //         answer: "Without proper treatment, asthma can worsen and cause permanent airway changes. However, with good control and regular monitoring, most people maintain stable asthma throughout their lives."
  //       }
  //     ]
  //   }
  //   // Add other procedures as needed
  // };
    const proceduresData = {
    'asthma': {
      title: "Asthma",
      category: "Chronic Respiratory Condition",
      tagline: "Comprehensive Asthma Management & Care",
      heroImage: "https://images.unsplash.com/photo-1584362917165-526a968579e8?w=1200&q=90",
      icon: "🫁",
      color: "#2C85B8",
      duration: "Ongoing Management",
      
      overview: "Asthma is a chronic respiratory condition that causes inflammation and narrowing of the airways, leading to difficulty breathing. Our comprehensive asthma management program provides personalized care through accurate diagnosis, effective treatment plans, and ongoing support to help you live a full, active life.",
      
      whatIsIt: "Asthma is a chronic inflammatory disease of the airways characterized by variable and recurring symptoms, reversible airflow obstruction, and bronchospasm. It affects people of all ages and can range from mild to severe, potentially life-threatening cases.",
      
      symptoms: [
        {
          name: "Wheezing",
          description: "A whistling sound when breathing, especially during exhalation"
        },
        {
          name: "Shortness of Breath",
          description: "Difficulty breathing or feeling like you can't get enough air"
        },
        {
          name: "Chest Tightness",
          description: "Feeling of pressure or constriction in the chest"
        },
        {
          name: "Persistent Coughing",
          description: "Frequent coughing, especially at night or early morning"
        },
        {
          name: "Difficulty Sleeping",
          description: "Breathing problems that wake you up or prevent sleep"
        },
        {
          name: "Exercise Intolerance",
          description: "Breathing difficulties during or after physical activity"
        }
      ],
      
      causes: [
        "Genetic predisposition and family history",
        "Environmental allergens (pollen, dust mites, pet dander)",
        "Respiratory infections, especially in childhood",
        "Air pollution and cigarette smoke exposure",
        "Occupational irritants and chemicals",
        "Cold air, exercise, and stress triggers"
      ],
      
      treatments: [
        {
          title: "Inhaler Therapy",
          description: "Quick-relief and long-term control medications using inhalers and spacers for effective drug delivery"
        },
        {
          title: "Nebulization",
          description: "Medication delivered as a mist for severe symptoms or young children who can't use inhalers"
        },
        {
          title: "Immunotherapy",
          description: "Allergy shots or sublingual tablets to reduce sensitivity to specific allergens"
        },
        {
          title: "Oral Medications",
          description: "Leukotriene modifiers, theophylline, and oral steroids for severe cases"
        },
        {
          title: "Biologic Therapies",
          description: "Advanced injectable medications for severe, uncontrolled asthma"
        },
        {
          title: "Lifestyle Management",
          description: "Trigger avoidance, breathing exercises, and asthma action plan development"
        }
      ],
      
      diagnosis: [
        "Detailed medical history and physical examination",
        "Spirometry to measure lung function",
        "Peak flow monitoring",
        "Chest X-ray to rule out other conditions",
        "Allergy testing to identify triggers",
        "Bronchial provocation tests if needed"
      ],
      
      prevention: [
        "Identify and avoid asthma triggers",
        "Take medications as prescribed",
        "Monitor breathing and symptoms daily",
        "Get vaccinated against flu and pneumonia",
        "Maintain a healthy weight",
        "Practice breathing exercises regularly"
      ],
      
      faqs: [
        {
          question: "Can asthma be cured?",
          answer: "Asthma cannot be cured, but it can be effectively managed. With proper treatment and trigger avoidance, most people with asthma can live normal, active lives with minimal symptoms."
        },
        {
          question: "Will I need to use an inhaler forever?",
          answer: "Many people need long-term inhaler use to control asthma. However, some children may outgrow their asthma, and medication needs can change over time. Your doctor will regularly assess whether you can reduce or modify your treatment."
        },
        {
          question: "Is it safe to exercise with asthma?",
          answer: "Yes, with proper management. Exercise is actually beneficial for people with asthma. Use your preventer inhaler before exercise, warm up properly, and have your rescue inhaler available. Inform your doctor about exercise-induced symptoms."
        },
        {
          question: "What should I do during an asthma attack?",
          answer: "Sit upright, stay calm, take your rescue inhaler (2-4 puffs), breathe slowly and deeply. If symptoms don't improve in 5-10 minutes, repeat. Call emergency services if there's no improvement or if you experience severe symptoms."
        },
        {
          question: "Can asthma get worse over time?",
          answer: "Without proper treatment, asthma can worsen and cause permanent airway changes. However, with good control and regular monitoring, most people maintain stable asthma throughout their lives."
        }
      ]
    },
    
    'allergies': {
      title: "Allergies",
      category: "Immune System Response",
      tagline: "Expert Allergy Diagnosis & Treatment",
      heroImage: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1200&q=90",
      icon: "🤧",
      color: "#FF9B6E",
      duration: "Varies by Type",
      
      overview: "Allergies occur when your immune system reacts to a foreign substance that doesn't cause a reaction in most people. Our comprehensive allergy care includes advanced testing, personalized treatment plans, and immunotherapy to help you manage symptoms and improve your quality of life.",
      
      whatIsIt: "An allergy is an immune system response to a substance (allergen) that is usually harmless. When you have allergies, your immune system makes antibodies that identify a particular allergen as harmful, triggering inflammation and various symptoms throughout the body.",
      
      symptoms: [
        {
          name: "Sneezing & Runny Nose",
          description: "Frequent sneezing and nasal discharge, especially seasonal"
        },
        {
          name: "Itchy, Watery Eyes",
          description: "Red, irritated eyes with excessive tearing"
        },
        {
          name: "Skin Reactions",
          description: "Hives, eczema, or contact dermatitis with itching"
        },
        {
          name: "Nasal Congestion",
          description: "Blocked nose and sinus pressure"
        },
        {
          name: "Throat Irritation",
          description: "Scratchy throat and post-nasal drip"
        },
        {
          name: "Digestive Issues",
          description: "Nausea, vomiting, or diarrhea from food allergies"
        }
      ],
      
      causes: [
        "Airborne allergens (pollen, dust mites, mold)",
        "Food allergies (nuts, shellfish, milk, eggs)",
        "Insect stings (bee, wasp venom)",
        "Medications (penicillin, aspirin)",
        "Latex and other materials",
        "Pet dander and animal proteins"
      ],
      
      treatments: [
        {
          title: "Comprehensive Allergy Testing",
          description: "Skin prick tests and blood tests to identify specific allergens causing your symptoms"
        },
        {
          title: "Immunotherapy",
          description: "Allergy shots or sublingual tablets to gradually desensitize your immune system"
        },
        {
          title: "Antihistamines",
          description: "Oral and nasal antihistamines to block histamine and relieve symptoms"
        },
        {
          title: "Nasal Corticosteroids",
          description: "Nasal sprays to reduce inflammation and prevent allergy symptoms"
        },
        {
          title: "Epinephrine Auto-injectors",
          description: "Emergency treatment for severe allergic reactions (anaphylaxis)"
        },
        {
          title: "Avoidance Strategies",
          description: "Personalized plans to minimize exposure to identified allergens"
        }
      ],
      
      diagnosis: [
        "Detailed symptom history and triggers",
        "Skin prick testing for immediate allergies",
        "Blood tests (IgE antibody testing)",
        "Patch testing for contact allergies",
        "Food elimination diets if needed",
        "Challenge tests under medical supervision"
      ],
      
      prevention: [
        "Identify and avoid known allergens",
        "Keep windows closed during high pollen days",
        "Use HEPA filters in home",
        "Wash bedding in hot water weekly",
        "Remove shoes at door to avoid tracking allergens",
        "Consider allergy-proof bedding covers"
      ],
      
      faqs: [
        {
          question: "Can allergies develop later in life?",
          answer: "Yes, you can develop new allergies at any age. While many allergies begin in childhood, it's not uncommon for adults to develop allergies to substances they were previously tolerant of."
        },
        {
          question: "How long does immunotherapy take to work?",
          answer: "Most people see improvement within 3-6 months of starting immunotherapy, but it typically takes 3-5 years of treatment for long-lasting effects. Some people may need to continue treatment longer for optimal results."
        },
        {
          question: "Are allergy medications safe for long-term use?",
          answer: "Yes, most allergy medications are safe for long-term use when taken as directed. However, regular follow-up with your doctor is important to assess effectiveness and adjust treatment as needed."
        },
        {
          question: "What's the difference between allergies and cold?",
          answer: "Allergies cause itchy eyes, nose, and throat, with clear, thin nasal discharge, lasting as long as you're exposed to the allergen. Colds cause body aches, fever, and thick nasal discharge, typically lasting 7-10 days."
        },
        {
          question: "Can I outgrow my allergies?",
          answer: "Some children outgrow certain allergies, especially food allergies like milk and egg. However, respiratory allergies often persist into adulthood, though symptoms may change in severity over time."
        }
      ]
    },

    'snoring': {
      title: "Snoring & Sleep Apnea",
      category: "Sleep Disorder Management",
      tagline: "Advanced Sleep Breathing Solutions",
      heroImage: "https://images.unsplash.com/photo-1541480551145-2370a440d585?w=1200&q=90",
      icon: "😴",
      color: "#1B4965",
      duration: "Ongoing Management",
      
      overview: "Sleep apnea is a serious sleep disorder where breathing repeatedly stops and starts during sleep. We provide comprehensive diagnosis through sleep studies and offer various treatment options including CPAP therapy, oral appliances, and surgical interventions.",
      
      whatIsIt: "Sleep apnea is a potentially serious sleep disorder characterized by repeated breathing interruptions during sleep. The most common type, obstructive sleep apnea (OSA), occurs when throat muscles intermittently relax and block the airway during sleep.",
      
      symptoms: [
        {
          name: "Loud Snoring",
          description: "Persistent loud snoring that disturbs sleep partners"
        },
        {
          name: "Breathing Cessation",
          description: "Episodes of stopped breathing during sleep (observed by others)"
        },
        {
          name: "Gasping for Air",
          description: "Abrupt awakenings accompanied by gasping or choking"
        },
        {
          name: "Morning Headache",
          description: "Waking up with headaches"
        },
        {
          name: "Excessive Daytime Sleepiness",
          description: "Difficulty staying awake during the day"
        },
        {
          name: "Irritability",
          description: "Mood changes, irritability, or depression"
        }
      ],
      
      causes: [
        "Excess weight and obesity",
        "Neck circumference and anatomy",
        "Narrowed airway",
        "Being male (risk increases for women after menopause)",
        "Family history and genetics",
        "Alcohol and sedative use before bed"
      ],
      
      treatments: [
        {
          title: "CPAP Therapy",
          description: "Continuous Positive Airway Pressure machine keeps airways open during sleep"
        },
        {
          title: "Oral Appliances",
          description: "Custom-fitted devices that keep throat open by bringing jaw forward"
        },
        {
          title: "Lifestyle Modifications",
          description: "Weight loss, positional therapy, avoiding alcohol and sedatives"
        },
        {
          title: "Surgical Options",
          description: "Tissue removal, jaw repositioning, or implants for severe cases"
        },
        {
          title: "BiPAP Therapy",
          description: "Bilevel Positive Airway Pressure for those who can't tolerate CPAP"
        },
        {
          title: "Hypoglossal Nerve Stimulation",
          description: "Implanted device that stimulates nerve controlling tongue movement"
        }
      ],
      
      diagnosis: [
        "Sleep history and symptoms assessment",
        "Polysomnography (overnight sleep study)",
        "Home sleep apnea testing",
        "Physical examination of mouth and throat",
        "Epworth Sleepiness Scale",
        "Oxygen saturation monitoring"
      ],
      
      prevention: [
        "Maintain healthy weight",
        "Exercise regularly",
        "Avoid alcohol and sedatives before bed",
        "Sleep on your side",
        "Keep nasal passages open at night",
        "Quit smoking"
      ],
      
      faqs: [
        {
          question: "Is sleep apnea dangerous?",
          answer: "Yes, untreated sleep apnea can lead to high blood pressure, heart problems, type 2 diabetes, liver problems, and increased risk of accidents due to daytime drowsiness."
        },
        {
          question: "Will I need to use CPAP forever?",
          answer: "Many people need long-term CPAP use. However, if you lose significant weight or undergo successful surgery, you may be able to reduce or stop treatment."
        },
        {
          question: "Can children have sleep apnea?",
          answer: "Yes, children can develop sleep apnea, often due to enlarged tonsils and adenoids. Treatment may include surgical removal."
        },
        {
          question: "How long does it take to adjust to CPAP?",
          answer: "Most people adapt within 2-4 weeks. Initially it may feel uncomfortable, but consistent use and proper mask fitting help with adjustment."
        },
        {
          question: "Can sleep apnea be cured?",
          answer: "While OSA can be effectively managed, it's rarely 'cured.' Weight loss can sometimes eliminate mild OSA, and surgery may help some cases."
        }
      ]
    },

    'adenoids': {
      title: "Adenoids",
      category: "Lymphoid Tissue Disorder",
      tagline: "Expert Adenoid Care for Children & Adults",
      heroImage: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=90",
      icon: "👶",
      color: "#E86A33",
      duration: "Varies",
      
      overview: "Enlarged adenoids can cause breathing difficulties, especially in children. We provide comprehensive diagnosis and treatment including medical management and minimally invasive surgical options when necessary.",
      
      whatIsIt: "Adenoids are glands located in the throat behind the nose. They help fight infections in infants and young children but typically shrink by adolescence. When enlarged, they can block airways and cause various symptoms.",
      
      symptoms: [
        {
          name: "Mouth Breathing",
          description: "Breathing through mouth instead of nose, especially during sleep"
        },
        {
          name: "Loud Snoring",
          description: "Persistent snoring in children"
        },
        {
          name: "Nasal Congestion",
          description: "Stuffy nose despite no cold or allergies"
        },
        {
          name: "Recurrent Ear Infections",
          description: "Frequent middle ear infections"
        },
        {
          name: "Sleep Disturbances",
          description: "Restless sleep and sleep apnea"
        },
        {
          name: "Nasal Speech",
          description: "Talking through nose with muffled voice"
        }
      ],
      
      causes: [
        "Viral and bacterial infections",
        "Allergies",
        "Genetics and family history",
        "Exposure to irritants",
        "Congenital enlargement",
        "Chronic inflammation"
      ],
      
      treatments: [
        {
          title: "Antibiotics",
          description: "For bacterial infections causing adenoid inflammation"
        },
        {
          title: "Nasal Steroid Sprays",
          description: "To reduce inflammation and swelling"
        },
        {
          title: "Adenoidectomy",
          description: "Surgical removal of adenoids for persistent problems"
        },
        {
          title: "Watchful Waiting",
          description: "Monitoring mild cases as adenoids may shrink naturally with age"
        },
        {
          title: "Allergy Management",
          description: "Treating underlying allergies to reduce adenoid swelling"
        },
        {
          title: "Pain Management",
          description: "Managing discomfort during acute infections"
        }
      ],
      
      diagnosis: [
        "Physical examination",
        "Medical history review",
        "Nasal endoscopy",
        "X-ray or CT scan",
        "Sleep study if apnea suspected",
        "Allergy testing if indicated"
      ],
      
      prevention: [
        "Practice good hygiene",
        "Avoid exposure to secondhand smoke",
        "Manage allergies effectively",
        "Maintain healthy immune system",
        "Regular medical check-ups",
        "Avoid known irritants"
      ],
      
      faqs: [
        {
          question: "At what age do adenoids typically shrink?",
          answer: "Adenoids usually start shrinking around age 5-7 and continue to decrease in size through adolescence. By adulthood, they're typically very small."
        },
        {
          question: "Is adenoid surgery safe for children?",
          answer: "Yes, adenoidectomy is a very safe and common procedure for children. It's performed under general anesthesia and most children recover quickly within a few days."
        },
        {
          question: "Will my child's speech improve after surgery?",
          answer: "Yes, if enlarged adenoids were causing nasal speech, improvement is typically seen within weeks after surgery as nasal airflow normalizes."
        },
        {
          question: "Can adenoids grow back after surgery?",
          answer: "Rarely, adenoid tissue can regrow, but this is uncommon. If it occurs, symptoms may return and further evaluation may be needed."
        },
        {
          question: "How long is recovery after adenoidectomy?",
          answer: "Most children recover within 1-2 weeks. Pain is usually mild and managed with over-the-counter medications. Normal activities can typically resume within a week."
        }
      ]
    },

    'tonsils': {
      title: "Tonsillitis",
      category: "Throat Infection",
      tagline: "Complete Tonsillitis Treatment & Care",
      heroImage: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1200&q=90",
      icon: "🤒",
      color: "#62B6CB",
      duration: "1-2 Weeks Acute",
      
      overview: "Tonsillitis is inflammation of the tonsils caused by viral or bacterial infection. We provide expert diagnosis and treatment including antibiotics, pain management, and surgical options for recurrent cases.",
      
      whatIsIt: "Tonsillitis is an infection and inflammation of the tonsils - two oval-shaped pads of tissue at the back of the throat. It's most common in children but can occur at any age.",
      
      symptoms: [
        {
          name: "Sore Throat",
          description: "Severe throat pain, especially when swallowing"
        },
        {
          name: "Swollen Tonsils",
          description: "Red, swollen tonsils with white or yellow coating"
        },
        {
          name: "Difficulty Swallowing",
          description: "Painful swallowing of food or liquids"
        },
        {
          name: "Fever",
          description: "High temperature above 100.4°F (38°C)"
        },
        {
          name: "Swollen Lymph Nodes",
          description: "Tender, enlarged lymph nodes in neck"
        },
        {
          name: "Bad Breath",
          description: "Persistent foul breath (halitosis)"
        }
      ],
      
      causes: [
        "Viral infections (most common)",
        "Streptococcus bacteria (strep throat)",
        "Other bacterial infections",
        "Weakened immune system",
        "Exposure to infected individuals",
        "Poor hygiene practices"
      ],
      
      treatments: [
        {
          title: "Antibiotics",
          description: "For bacterial tonsillitis, typically 10-day course of penicillin or alternatives"
        },
        {
          title: "Pain Relief",
          description: "Over-the-counter pain relievers and throat lozenges"
        },
        {
          title: "Rest and Hydration",
          description: "Plenty of rest and fluids to aid recovery"
        },
        {
          title: "Tonsillectomy",
          description: "Surgical removal for recurrent tonsillitis (7+ episodes per year)"
        },
        {
          title: "Corticosteroids",
          description: "To reduce severe inflammation when needed"
        },
        {
          title: "Supportive Care",
          description: "Warm saltwater gargles, humidifier use, soft foods"
        }
      ],
      
      diagnosis: [
        "Physical examination of throat",
        "Rapid strep test",
        "Throat culture",
        "Complete blood count (CBC)",
        "Monospot test if mononucleosis suspected",
        "Medical history review"
      ],
      
      prevention: [
        "Wash hands frequently",
        "Avoid sharing utensils or drinks",
        "Replace toothbrush after diagnosis",
        "Avoid close contact with sick individuals",
        "Maintain strong immune system",
        "Practice good oral hygiene"
      ],
      
      faqs: [
        {
          question: "Is tonsillitis contagious?",
          answer: "Yes, both viral and bacterial tonsillitis are contagious. The infection spreads through respiratory droplets from coughing or sneezing. Practice good hygiene to prevent transmission."
        },
        {
          question: "When should tonsils be removed?",
          answer: "Tonsillectomy is considered for recurrent tonsillitis (7+ episodes in one year, 5+ for two years, or 3+ for three years), sleep-disordered breathing, or abscess formation."
        },
        {
          question: "Can adults get tonsillitis?",
          answer: "Yes, although more common in children, adults can develop tonsillitis. Adult cases may be more severe and take longer to recover."
        },
        {
          question: "How long is tonsillitis contagious?",
          answer: "Viral tonsillitis is contagious throughout the illness. Bacterial tonsillitis is contagious until 24 hours after starting antibiotics."
        },
        {
          question: "What's the difference between tonsillitis and strep throat?",
          answer: "Strep throat is bacterial tonsillitis specifically caused by Streptococcus bacteria. Tonsillitis can be viral or bacterial. Strep throat requires antibiotics."
        }
      ]
    },

    'sinusitis': {
      title: "Sinusitis",
      category: "Sinus Inflammation",
      tagline: "Advanced Sinusitis Treatment & Care",
      heroImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=90",
      icon: "👃",
      color: "#2C5F7C",
      duration: "2-12 Weeks",
      
      overview: "Sinusitis is inflammation of the sinuses causing facial pain, nasal congestion, and discharge. Our comprehensive treatment approach includes advanced diagnostics, medical therapy, and endoscopic surgery when needed for chronic cases.",
      
      whatIsIt: "Sinusitis is inflammation or swelling of the tissue lining the sinuses. It can be acute (lasting less than 4 weeks), subacute (4-12 weeks), chronic (lasting more than 12 weeks), or recurrent (several episodes within a year).",
      
      symptoms: [
        {
          name: "Facial Pain & Pressure",
          description: "Pain and pressure around eyes, cheeks, nose, or forehead"
        },
        {
          name: "Nasal Congestion",
          description: "Stuffy nose and difficulty breathing through nose"
        },
        {
          name: "Thick Nasal Discharge",
          description: "Yellow or greenish discharge from nose or down throat"
        },
        {
          name: "Reduced Sense of Smell",
          description: "Decreased ability to smell and taste"
        },
        {
          name: "Headache",
          description: "Pain in forehead, temples, or behind eyes"
        },
        {
          name: "Post-Nasal Drip",
          description: "Mucus draining down the back of throat"
        }
      ],
      
      causes: [
        "Viral infections (common cold)",
        "Bacterial infections",
        "Nasal polyps or deviated septum",
        "Allergies and hay fever",
        "Air pollution and irritants",
        "Weakened immune system"
      ],
      
      treatments: [
        {
          title: "Antibiotics",
          description: "For bacterial sinusitis to eliminate infection and reduce inflammation"
        },
        {
          title: "Nasal Corticosteroid Sprays",
          description: "To reduce inflammation and improve drainage"
        },
        {
          title: "Saline Irrigation",
          description: "Nasal rinses to flush out mucus and moisturize passages"
        },
        {
          title: "Decongestants",
          description: "Short-term use to relieve nasal congestion"
        },
        {
          title: "Endoscopic Sinus Surgery",
          description: "For chronic sinusitis not responding to medical treatment"
        },
        {
          title: "Steam Inhalation",
          description: "To loosen mucus and relieve congestion"
        }
      ],
      
      diagnosis: [
        "Physical examination of nose and throat",
        "Nasal endoscopy",
        "CT scan of sinuses",
        "Allergy testing",
        "Nasal and sinus cultures",
        "Biopsy (if needed)"
      ],
      
      prevention: [
        "Practice good hand hygiene",
        "Avoid known allergens",
        "Use a humidifier",
        "Stay hydrated",
        "Avoid cigarette smoke",
        "Manage allergies effectively"
      ],
      
      faqs: [
        {
          question: "How long does sinusitis last?",
          answer: "Acute sinusitis typically lasts 2-4 weeks. Chronic sinusitis persists for 12 weeks or longer. With proper care, most acute cases resolve within 10 days."
        },
        {
          question: "Is sinusitis contagious?",
          answer: "Sinusitis itself is not contagious, but the viruses that can lead to sinusitis are contagious. Bacterial sinusitis is generally not contagious."
        },
        {
          question: "When should I see a doctor?",
          answer: "See a doctor if symptoms last more than 10 days, you have high fever, severe headache, vision changes, or symptoms worsen after initial improvement."
        },
        {
          question: "Can I prevent recurrent sinusitis?",
          answer: "Yes, by managing allergies, avoiding irritants, practicing good hygiene, staying hydrated, and treating underlying conditions."
        },
        {
          question: "Do I need surgery for sinusitis?",
          answer: "Surgery is typically considered only when conservative treatments fail and chronic sinusitis significantly affects quality of life."
        }
      ]
    },

    'copd': {
      title: "COPD",
      category: "Chronic Obstructive Pulmonary Disease",
      tagline: "Comprehensive COPD Management",
      heroImage: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=1200&q=90",
      icon: "🫁",
      color: "#E63946",
      duration: "Chronic Condition",
      
      overview: "COPD is a progressive lung disease making breathing difficult. Our specialized program provides medication management, pulmonary rehabilitation, oxygen therapy, and lifestyle support for better breathing and quality of life.",
      
      whatIsIt: "COPD is a chronic inflammatory lung disease causing obstructed airflow from lungs. It includes emphysema and chronic bronchitis, typically caused by long-term exposure to irritating gases, most often from cigarette smoke.",
      
      symptoms: [
        {
          name: "Chronic Cough",
          description: "Persistent cough producing mucus, especially in morning"
        },
        {
          name: "Shortness of Breath",
          description: "Breathlessness, especially during physical activities"
        },
        {
          name: "Wheezing",
          description: "Whistling sound when breathing"
        },
        {
          name: "Chest Tightness",
          description: "Feeling of pressure or squeezing in chest"
        },
        {
          name: "Frequent Infections",
          description: "Increased susceptibility to colds, flu, and pneumonia"
        },
        {
          name: "Fatigue",
          description: "Lack of energy and constant tiredness"
        }
      ],
      
      causes: [
        "Cigarette smoking (primary cause)",
        "Long-term exposure to secondhand smoke",
        "Occupational dust and chemicals",
        "Indoor air pollution from cooking and heating",
        "Alpha-1 antitrypsin deficiency (genetic)",
        "Chronic asthma in some cases"
      ],
      
      treatments: [
        {
          title: "Bronchodilators",
          description: "Short and long-acting inhalers to relax airway muscles"
        },
        {
          title: "Inhaled Corticosteroids",
          description: "Anti-inflammatory medications to reduce airway inflammation"
        },
        {
          title: "Oxygen Therapy",
          description: "Supplemental oxygen for severe COPD to maintain blood oxygen"
        },
        {
          title: "Pulmonary Rehabilitation",
          description: "Exercise training, education, and support for well-being"
        },
        {
          title: "Antibiotics & Antivirals",
          description: "Treatment for respiratory infections worsening COPD"
        },
        {
          title: "Surgery",
          description: "Lung volume reduction surgery or transplant for severe cases"
        }
      ],
      
      diagnosis: [
        "Spirometry to measure lung function",
        "Chest X-ray or CT scan",
        "Arterial blood gas analysis",
        "Lab tests to rule out other conditions",
        "Alpha-1 antitrypsin screening",
        "Regular symptom and lung function monitoring"
      ],
      
      prevention: [
        "Quit smoking immediately (most important)",
        "Avoid secondhand smoke and pollutants",
        "Get annual flu and pneumonia vaccines",
        "Maintain healthy weight",
        "Exercise regularly as tolerated",
        "Use protective equipment for occupational exposures"
      ],
      
      faqs: [
        {
          question: "Can COPD be reversed?",
          answer: "COPD damage cannot be reversed, but symptoms can be managed and progression slowed with proper treatment, especially if you quit smoking early."
        },
        {
          question: "How long can you live with COPD?",
          answer: "Life expectancy varies greatly depending on severity, age, smoking status, and overall health. Many with mild to moderate COPD live 10-20+ years after diagnosis."
        },
        {
          question: "Should I continue exercising with COPD?",
          answer: "Yes, regular exercise is crucial. Pulmonary rehabilitation programs teach you how to exercise safely and effectively."
        },
        {
          question: "When will I need oxygen therapy?",
          answer: "Oxygen therapy is prescribed when blood oxygen levels are consistently too low (typically below 88-92%). Regular monitoring determines when it's needed."
        },
        {
          question: "What are COPD exacerbations?",
          answer: "Exacerbations are flare-ups where symptoms suddenly worsen. They can be triggered by infections or pollution. Prompt treatment is essential."
        }
      ]
    },

    'ild': {
      title: "ILD (Interstitial Lung Disease)",
      category: "Lung Tissue Disorders",
      tagline: "Advanced ILD Diagnosis & Management",
      heroImage: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=90",
      icon: "🫁",
      color: "#457B9D",
      duration: "Chronic Management",
      
      overview: "ILD encompasses disorders causing progressive lung scarring. We provide advanced diagnosis through HRCT, lung biopsy, immunosuppressive therapy, and oxygen support for improved quality of life.",
      
      whatIsIt: "Interstitial lung disease describes a large group of disorders causing progressive scarring (fibrosis) of lung tissue. This scarring affects ability to breathe and get oxygen to bloodstream.",
      
      symptoms: [
        {
          name: "Progressive Dyspnea",
          description: "Gradually worsening shortness of breath with activity"
        },
        {
          name: "Dry Cough",
          description: "Persistent non-productive cough"
        },
        {
          name: "Fatigue",
          description: "Constant tiredness and weakness"
        },
        {
          name: "Weight Loss",
          description: "Unintentional weight loss"
        },
        {
          name: "Clubbing",
          description: "Widening and rounding of fingertips"
        },
        {
          name: "Chest Discomfort",
          description: "Aching or discomfort in chest"
        }
      ],
      
      causes: [
        "Occupational exposures (asbestos, silica)",
        "Autoimmune diseases",
        "Medications and treatments",
        "Radiation therapy",
        "Environmental factors",
        "Idiopathic (unknown cause)"
      ],
      
      treatments: [
        {
          title: "Immunosuppressants",
          description: "Corticosteroids and other drugs to reduce inflammation"
        },
        {
          title: "Antifibrotic Agents",
          description: "Medications to slow lung scarring progression"
        },
        {
          title: "Oxygen Therapy",
          description: "Supplemental oxygen to maintain adequate blood oxygen"
        },
        {
          title: "Pulmonary Rehabilitation",
          description: "Exercise and education program to improve function"
        },
        {
          title: "Lung Transplant Evaluation",
          description: "Assessment for transplant candidacy in advanced cases"
        },
        {
          title: "Supportive Care",
          description: "Managing symptoms and preventing complications"
        }
      ],
      
      diagnosis: [
        "High-resolution CT (HRCT) scan",
        "Pulmonary function tests",
        "Arterial blood gas analysis",
        "Bronchoscopy with biopsy",
        "Surgical lung biopsy if needed",
        "Blood tests for autoimmune markers"
      ],
      
      prevention: [
        "Avoid occupational exposures",
        "Don't smoke",
        "Protect against environmental hazards",
        "Regular health screenings if at risk",
        "Manage underlying autoimmune conditions",
        "Follow medication guidelines carefully"
      ],
      
      faqs: [
        {
          question: "Is ILD curable?",
          answer: "Most ILD types cannot be cured, but progression can be slowed with proper treatment. Some cases caused by medications may improve when the drug is stopped."
        },
        {
          question: "How fast does ILD progress?",
          answer: "Progression varies widely depending on ILD type and individual factors. Some progress slowly over years, while others advance more rapidly."
        },
        {
          question: "Will I need oxygen therapy?",
          answer: "Many people with ILD eventually need supplemental oxygen, especially during activity or sleep. Your doctor monitors oxygen levels to determine when it's needed."
        },
        {
          question: "Can I exercise with ILD?",
          answer: "Yes, exercise is encouraged. Pulmonary rehabilitation helps you exercise safely while managing symptoms. Start slowly and gradually increase activity."
        },
        {
          question: "What's the life expectancy with ILD?",
          answer: "Life expectancy varies greatly depending on ILD type, severity, and response to treatment. Some people live many years with proper management."
        }
      ]
    },

    'obesity': {
      title: "Obesity & Metabolic Disorders",
      category: "Weight Management",
      tagline: "Comprehensive Weight Management Program",
      heroImage: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200&q=90",
      icon: "⚖️",
      color: "#FF9B6E",
      duration: "Ongoing Program",
      
      overview: "Obesity affects breathing and overall health. Our comprehensive program includes dietary counseling, exercise plans, medical therapy, and surgical referrals when appropriate for sustainable weight management.",
      
      whatIsIt: "Obesity is a complex disease involving excessive body fat that increases risk of health problems. It affects breathing, causes sleep apnea, and contributes to numerous metabolic disorders.",
      
      symptoms: [
        {
          name: "Excess Weight",
          description: "BMI of 30 or higher"
        },
        {
          name: "Breathing Difficulties",
          description: "Shortness of breath with minimal exertion"
        },
        {
          name: "Sleep Apnea",
          description: "Interrupted breathing during sleep"
        },
        {
          name: "Joint Pain",
          description: "Pain in knees, hips, and back"
        },
        {
          name: "Fatigue",
          description: "Low energy and constant tiredness"
        },
        {
          name: "Sweating",
          description: "Excessive sweating even with light activity"
        }
      ],
      
      causes: [
        "Poor diet and eating habits",
        "Physical inactivity",
        "Genetics and family history",
        "Medical conditions and medications",
        "Psychological factors",
        "Lack of sleep"
      ],
      
      treatments: [
        {
          title: "Dietary Counseling",
          description: "Personalized nutrition plans with registered dietitian"
        },
        {
          title: "Exercise Programs",
          description: "Structured physical activity plans tailored to fitness level"
        },
        {
          title: "Behavioral Therapy",
          description: "Addressing emotional and psychological aspects of eating"
        },
        {
          title: "Medical Therapy",
          description: "Weight loss medications when appropriate"
        },
        {
          title: "Bariatric Surgery Referral",
          description: "Surgical options for severe obesity when other methods fail"
        },
        {
          title: "Support Groups",
          description: "Peer support and accountability for sustained success"
        }
      ],
      
      diagnosis: [
        "BMI calculation",
        "Waist circumference measurement",
        "Body composition analysis",
        "Blood tests (cholesterol, glucose, thyroid)",
        "Sleep study if apnea suspected",
        "Assessment of related health conditions"
      ],
      
      prevention: [
        "Maintain balanced, healthy diet",
        "Regular physical activity (150 min/week)",
        "Adequate sleep (7-9 hours)",
        "Stress management",
        "Avoid processed and high-calorie foods",
        "Regular health check-ups"
      ],
      
      faqs: [
        {
          question: "How much weight should I aim to lose?",
          answer: "Even a 5-10% weight loss can significantly improve health. Set realistic goals with your healthcare team - typically 1-2 pounds per week is healthy."
        },
        {
          question: "Will I regain weight after losing it?",
          answer: "Weight maintenance requires ongoing effort. Long-term success comes from sustainable lifestyle changes, not quick fixes. Regular follow-up and support help prevent regain."
        },
        {
          question: "Are weight loss medications safe?",
          answer: "FDA-approved weight loss medications are safe when used under medical supervision. They work best combined with diet and exercise, not as standalone treatment."
        },
        {
          question: "When is bariatric surgery considered?",
          answer: "Surgery is considered for BMI ≥40 or BMI ≥35 with obesity-related health problems when other weight loss methods haven't worked."
        },
        {
          question: "Can obesity affect my breathing?",
          answer: "Yes, excess weight restricts lung expansion, increases breathing effort, and commonly causes sleep apnea. Weight loss significantly improves respiratory function."
        }
      ]
    },

    'tb': {
      title: "Tuberculosis (TB)",
      category: "Bacterial Infection",
      tagline: "Complete TB Diagnosis & Treatment",
      heroImage: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=1200&q=90",
      icon: "🦠",
      color: "#E86A33",
      duration: "6-9 Months Treatment",
      
      overview: "TB is a serious bacterial infection primarily affecting lungs. Our comprehensive program provides accurate diagnosis, complete DOTS therapy, regular monitoring, and contact tracing to ensure cure and prevent spread.",
      
      whatIsIt: "Tuberculosis is caused by Mycobacterium tuberculosis bacteria. It spreads through air when infected person coughs or sneezes. TB can be latent (inactive) or active (symptomatic and contagious).",
      
      symptoms: [
        {
          name: "Persistent Cough",
          description: "Cough lasting more than 3 weeks, may produce blood"
        },
        {
          name: "Chest Pain",
          description: "Pain in chest, especially when breathing or coughing"
        },
        {
          name: "Fever & Night Sweats",
          description: "Low-grade fever and excessive night sweating"
        },
        {
          name: "Weight Loss",
          description: "Significant unintentional weight loss"
        },
        {
          name: "Loss of Appetite",
          description: "Decreased desire to eat"
        },
        {
          name: "Fatigue",
          description: "Constant tiredness and weakness"
        }
      ],
      
      causes: [
        "Inhalation of TB bacteria from infected person",
        "Weakened immune system (HIV, diabetes)",
        "Close contact with TB patients",
        "Living in crowded conditions",
        "Malnutrition and poverty",
        "Healthcare worker exposure"
      ],
      
      treatments: [
        {
          title: "DOTS Therapy",
          description: "Directly Observed Treatment Short-course with supervision"
        },
        {
          title: "First-Line Drugs",
          description: "Combination of isoniazid, rifampicin, ethambutol, pyrazinamide"
        },
        {
          title: "Second-Line Drugs",
          description: "For drug-resistant TB, requiring 18-24 months"
        },
        {
          title: "Regular Monitoring",
          description: "Monthly check-ups, sputum tests, liver function monitoring"
        },
        {
          title: "Contact Tracing",
          description: "Screening family members and close contacts"
        },
        {
          title: "Preventive Therapy",
          description: "Treatment for latent TB to prevent active disease"
        }
      ],
      
      diagnosis: [
        "Tuberculin skin test (TST)",
        "Interferon-gamma release assays (IGRAs)",
        "Chest X-ray",
        "Sputum smear microscopy",
        "GeneXpert MTB/RIF test",
        "TB culture (gold standard)"
      ],
      
      prevention: [
        "BCG vaccination in endemic areas",
        "Avoid close contact with active TB cases",
        "Ensure good ventilation in living spaces",
        "Practice good hygiene and cough etiquette",
        "Strengthen immune system with healthy diet",
        "Complete preventive therapy if exposed"
      ],
      
      faqs: [
        {
          question: "Is TB curable?",
          answer: "Yes, TB is completely curable with proper treatment. You must take all medications exactly as prescribed for the full 6-9 months, even when feeling better."
        },
        {
          question: "How long am I contagious?",
          answer: "Most people become non-contagious within 2-3 weeks of starting proper treatment. Continue isolation as directed until tests confirm you're not infectious."
        },
        {
          question: "Can I get TB more than once?",
          answer: "Yes, you can get TB again after being cured, especially if exposed to someone with active TB and have weakened immunity."
        },
        {
          question: "What are TB medication side effects?",
          answer: "Common effects include nausea, loss of appetite, urine discoloration. Serious effects include liver problems and vision changes. Regular monitoring helps."
        },
        {
          question: "Do I need to isolate during treatment?",
          answer: "Initially yes, especially with pulmonary TB. Once on treatment and no longer contagious (usually 2-3 weeks), resume normal activities but complete full treatment."
        }
      ]
    },

    'lung-cancer': {
      title: "Lung Cancer",
      category: "Malignant Lung Growth",
      tagline: "Comprehensive Lung Cancer Care",
      heroImage: "https://images.unsplash.com/photo-1579684453423-f84349ef60b0?w=1200&q=90",
      icon: "🎗️",
      color: "#A8DADC",
      duration: "Varies by Stage",
      
      overview: "Lung cancer is a serious condition requiring prompt diagnosis and treatment. We provide early detection, comprehensive cancer care through bronchoscopy, biopsy, chemotherapy, radiation, and palliative care.",
      
      whatIsIt: "Lung cancer is uncontrolled growth of abnormal cells in one or both lungs. These cells can form tumors and interfere with lung function. It's the leading cause of cancer deaths worldwide.",
      
      symptoms: [
        {
          name: "Persistent Cough",
          description: "Cough that doesn't go away or worsens over time"
        },
        {
          name: "Hemoptysis",
          description: "Coughing up blood or rust-colored sputum"
        },
        {
          name: "Chest Pain",
          description: "Persistent pain that worsens with breathing or laughing"
        },
        {
          name: "Shortness of Breath",
          description: "Unexplained breathlessness or wheezing"
        },
        {
          name: "Weight Loss",
          description: "Unintentional significant weight loss"
        },
        {
          name: "Hoarseness",
          description: "Voice changes or persistent hoarseness"
        }
      ],
      
      causes: [
        "Cigarette smoking (primary cause - 80-90%)",
        "Secondhand smoke exposure",
        "Radon gas exposure",
        "Occupational exposures (asbestos, arsenic)",
        "Air pollution",
        "Family history of lung cancer"
      ],
      
      treatments: [
        {
          title: "Surgery",
          description: "Surgical removal of tumor and surrounding tissue"
        },
        {
          title: "Chemotherapy",
          description: "Drugs to kill cancer cells throughout body"
        },
        {
          title: "Radiation Therapy",
          description: "High-energy beams to destroy cancer cells"
        },
        {
          title: "Targeted Therapy",
          description: "Drugs targeting specific cancer cell abnormalities"
        },
        {
          title: "Immunotherapy",
          description: "Helping immune system fight cancer"
        },
        {
          title: "Palliative Care",
          description: "Managing symptoms and improving quality of life"
        }
      ],
      
      diagnosis: [
        "Chest X-ray",
        "CT scan",
        "PET scan",
        "Bronchoscopy with biopsy",
        "Sputum cytology",
        "Molecular testing of tumor"
      ],
      
      prevention: [
        "Don't smoke or quit smoking immediately",
        "Avoid secondhand smoke",
        "Test home for radon",
        "Avoid carcinogens at work",
        "Eat diet rich in fruits and vegetables",
        "Exercise regularly"
      ],
      
      faqs: [
        {
          question: "What is the survival rate for lung cancer?",
          answer: "Survival rates vary greatly by stage at diagnosis. Early-stage lung cancer (stage 1) has much better prognosis than advanced stages. Early detection is crucial."
        },
        {
          question: "Can non-smokers get lung cancer?",
          answer: "Yes, about 10-20% of lung cancers occur in people who never smoked. Causes include secondhand smoke, radon, air pollution, and genetic factors."
        },
        {
          question: "Is lung cancer screening recommended?",
          answer: "Yes, annual low-dose CT screening is recommended for high-risk individuals aged 50-80 with significant smoking history."
        },
        {
          question: "How is lung cancer staged?",
          answer: "Lung cancer is staged from 0 to 4 based on tumor size, lymph node involvement, and spread to other organs. Staging guides treatment decisions."
        },
        {
          question: "Can lung cancer be cured?",
          answer: "Early-stage lung cancer can often be cured with surgery. Advanced stages may not be curable but can be treated to extend life and improve quality."
        }
      ]
    }
  };


  const procedure = proceduresData[procedureId];

  if (!procedure) {
    return (
      <div style={{padding: '4rem 2rem', textAlign: 'center', minHeight: '100vh'}}>
        <h2>Procedure not found</h2>
        <Link to="/procedures" style={{color: '#E86A33'}}>Back to Procedures</Link>
      </div>
    );
  }

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', sans-serif;
          color: #1a1a1a;
        }

        .procedure-detail-redesigned {
          width: 100%;
          min-height: 100vh;
          background: #FAFBFC;
        }

        /* Compact Hero Section */
        .procedure-hero-compact {
          position: relative;
          background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
          padding: 3rem 2rem 2rem;
        }

        .procedure-hero-compact::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 50%;
          height: 100%;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="rgba(232,106,51,0.1)"/></svg>');
          background-size: 60px;
          opacity: 0.3;
        }

        .hero-content-compact {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .back-link-compact {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: white;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 2rem;
          padding: 0.6rem 1.2rem;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          font-size: 0.9rem;
          transition: all 0.3s ease;
        }

        .back-link-compact:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateX(-5px);
        }

        .hero-grid {
          display: grid;
          grid-template-columns: auto 1fr auto;
          gap: 2rem;
          align-items: center;
        }

        .hero-icon-box {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
          backdrop-filter: blur(20px);
          border-radius: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3.5rem;
          border: 2px solid rgba(255, 255, 255, 0.3);
        }

        .hero-text {
          color: white;
        }

        .category-tag {
          display: inline-block;
          padding: 0.4rem 1rem;
          background: rgba(232, 106, 51, 0.2);
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 0.8rem;
          color: #FFD700;
        }

        .hero-title-compact {
          font-family: 'Playfair Display', serif;
          font-size: 2.8rem;
          font-weight: 800;
          margin-bottom: 0.5rem;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1.1rem;
          opacity: 0.9;
          font-weight: 400;
        }

        .hero-meta {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          padding: 1.5rem;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          border: 2px solid rgba(255, 255, 255, 0.2);
        }

        .meta-item-hero {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          color: white;
          font-size: 0.95rem;
          font-weight: 600;
        }

        /* Contact Strip */
        .contact-strip {
          background: white;
          border-bottom: 3px solid #E86A33;
          padding: 1.2rem 2rem;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
        }

        .contact-strip-content {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .contact-items {
          display: flex;
          gap: 2.5rem;
          flex-wrap: wrap;
        }

        .contact-item-strip {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          color: #1B4965;
          font-weight: 600;
          font-size: 0.95rem;
        }

        .contact-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .contact-item-strip a {
          color: #1B4965;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-item-strip a:hover {
          color: #E86A33;
        }

        .book-btn-strip {
          padding: 0.9rem 2.5rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.7rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
          text-decoration: none;
        }

        .book-btn-strip:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
        }

        /* Main Content */
        .procedure-main {
          max-width: 1400px;
          margin: 0 auto;
          padding: 3rem 2rem;
          display: grid;
          grid-template-columns: 3fr 1fr;
          gap: 3rem;
        }

        .overview-card {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
          margin-bottom: 2rem;
          border-left: 5px solid #2C85B8;
        }

        .overview-title {
          font-size: 2rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .overview-text {
          font-size: 1.05rem;
          line-height: 1.9;
          color: #444;
          margin-bottom: 1.5rem;
        }

        .tabs-container {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
          margin-bottom: 2rem;
        }

        .tabs-header {
          display: flex;
          background: #F8FAFB;
          border-bottom: 2px solid #E5E7EB;
        }

        .tab-button {
          flex: 1;
          padding: 1.2rem 1.5rem;
          background: transparent;
          border: none;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #666;
          position: relative;
        }

        .tab-button.active {
          color: #E86A33;
          background: white;
        }

        .tab-button.active::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #E86A33, #FF9B6E);
        }

        .tab-button:hover:not(.active) {
          color: #1B4965;
          background: rgba(232, 106, 51, 0.05);
        }

        .tab-content {
          padding: 2.5rem;
        }

        .symptoms-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.2rem;
        }

        .symptom-card-new {
          padding: 1.5rem;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
          border-radius: 15px;
          border: 2px solid #E5E7EB;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .symptom-card-new::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 0;
          background: linear-gradient(to bottom, #E86A33, #FF9B6E);
          transition: height 0.3s ease;
        }

        .symptom-card-new:hover {
          border-color: #E86A33;
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(232, 106, 51, 0.15);
        }

        .symptom-card-new:hover::before {
          height: 100%;
        }

        .symptom-name-new {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 0.6rem;
          display: flex;
          align-items: center;
          gap: 0.6rem;
        }

        .symptom-desc-new {
          font-size: 0.95rem;
          line-height: 1.6;
          color: #666;
        }

        .treatment-timeline {
          position: relative;
          padding-left: 2rem;
        }

        .treatment-timeline::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(to bottom, #2C85B8, #62B6CB);
        }

        .treatment-item {
          position: relative;
          margin-bottom: 2rem;
          padding-left: 2rem;
        }

        .treatment-item::before {
          content: '';
          position: absolute;
          left: -2.5rem;
          top: 0.5rem;
          width: 18px;
          height: 18px;
          background: white;
          border: 4px solid #2C85B8;
          border-radius: 50%;
          box-shadow: 0 0 0 4px rgba(44, 133, 184, 0.1);
        }

        .treatment-title-new {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 0.5rem;
        }

        .treatment-desc-new {
          font-size: 1rem;
          line-height: 1.7;
          color: #666;
        }

        .icon-list {
          display: grid;
          gap: 1rem;
        }

        .icon-list-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 1rem 1.2rem;
          background: #F8FAFB;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .icon-list-item:hover {
          background: white;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          transform: translateX(8px);
        }

        .list-icon-new {
          width: 24px;
          height: 24px;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
          margin-top: 0.1rem;
        }

        .faq-section {
          margin-top: 2rem;
        }

        .faq-item-new {
          background: white;
          border: 2px solid #E5E7EB;
          border-radius: 15px;
          margin-bottom: 1rem;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .faq-item-new.open {
          border-color: #2C85B8;
          box-shadow: 0 4px 20px rgba(44, 133, 184, 0.1);
        }

        .faq-question-new {
          padding: 1.5rem 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-weight: 700;
          font-size: 1.05rem;
          color: #1B4965;
          transition: all 0.3s ease;
          background: #F8FAFB;
        }

        .faq-item-new.open .faq-question-new {
          background: white;
          color: #2C85B8;
        }

        .faq-answer-new {
          padding: 0 2rem 1.5rem;
          font-size: 1rem;
          line-height: 1.8;
          color: #666;
        }

        .sidebar-new {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .info-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
          border-top: 4px solid #2C85B8;
        }

        .info-card-title {
          font-size: 1.3rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          padding: 1rem 0;
          border-bottom: 1px solid #F0F0F0;
        }

        .info-row:last-child {
          border-bottom: none;
        }

        .info-label {
          font-weight: 600;
          color: #666;
          font-size: 0.9rem;
        }

        .info-value {
          font-weight: 700;
          color: #1B4965;
          text-align: right;
        }

        .cta-card-new {
          background: linear-gradient(135deg, #2C85B8 0%, #1B4965 100%);
          color: white;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .cta-card-new::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(232, 106, 51, 0.2) 0%, transparent 70%);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }

        .cta-card-content {
          position: relative;
          z-index: 2;
        }

        .cta-title-new {
          font-size: 1.6rem;
          font-weight: 800;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .cta-text-new {
          font-size: 0.95rem;
          opacity: 0.95;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .cta-contacts {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          margin-bottom: 1.5rem;
        }

        .cta-contact-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          padding: 0.8rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          font-weight: 600;
          font-size: 0.9rem;
        }

        .cta-contact-item a {
          color: white;
          text-decoration: none;
        }

        .cta-button-new {
          width: 100%;
          padding: 1rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.7rem;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .cta-button-new:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(232, 106, 51, 0.4);
        }

        /* Responsive Design */
        @media (max-width: 1400px) {
          .procedure-main {
            padding: 2.5rem 1.5rem;
          }

          .hero-content-compact {
            padding: 0 1.5rem;
          }
        }

        @media (max-width: 1200px) {
          .hero-grid {
            gap: 1.5rem;
          }

          .procedure-main {
            gap: 2rem;
          }

          .symptoms-cards {
            gap: 1rem;
          }
        }

        @media (max-width: 1024px) {
          .procedure-main {
            grid-template-columns: 1fr;
            padding: 2rem 1.5rem;
          }

          .hero-grid {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 1.5rem;
          }

          .hero-icon-box {
            margin: 0 auto;
            width: 90px;
            height: 90px;
            font-size: 3rem;
          }

          .hero-meta {
            margin: 0 auto;
            max-width: 300px;
          }

          .symptoms-cards {
            grid-template-columns: 1fr;
          }

          .overview-card {
            padding: 2.5rem;
          }

          .tab-content {
            padding: 2rem;
          }

          .sidebar-new {
            margin-top: 0;
          }
        }

        @media (max-width: 768px) {
          .procedure-hero-compact {
            padding: 2rem 1rem 1.5rem;
          }

          .hero-content-compact {
            padding: 0 1rem;
          }

          .back-link-compact {
            margin-bottom: 1.5rem;
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }

          .hero-icon-box {
            width: 80px;
            height: 80px;
            font-size: 2.5rem;
            border-radius: 20px;
          }

          .category-tag {
            padding: 0.3rem 0.8rem;
            font-size: 0.75rem;
            margin-bottom: 0.6rem;
          }

          .hero-title-compact {
            font-size: 2rem;
            margin-bottom: 0.4rem;
          }

          .hero-subtitle {
            font-size: 1rem;
          }

          .hero-meta {
            padding: 1.2rem;
            gap: 0.6rem;
          }

          .meta-item-hero {
            font-size: 0.9rem;
          }

          .contact-strip {
            padding: 1rem;
          }

          .contact-strip-content {
            flex-direction: column;
            align-items: stretch;
            gap: 1rem;
          }

          .contact-items {
            flex-direction: column;
            gap: 0.8rem;
          }

          .contact-item-strip {
            font-size: 0.9rem;
          }

          .contact-icon {
            width: 35px;
            height: 35px;
          }

          .book-btn-strip {
            padding: 0.8rem 2rem;
            font-size: 0.95rem;
            width: 100%;
            justify-content: center;
          }

          .procedure-main {
            padding: 2rem 1rem;
            gap: 1.5rem;
          }

          .overview-card {
            padding: 2rem;
            border-radius: 15px;
            margin-bottom: 1.5rem;
          }

          .overview-title {
            font-size: 1.6rem;
            margin-bottom: 1.2rem;
          }

          .overview-text {
            font-size: 1rem;
            line-height: 1.7;
            margin-bottom: 1.2rem;
          }

          .tabs-container {
            border-radius: 15px;
            margin-bottom: 1.5rem;
          }

          .tabs-header {
            flex-wrap: wrap;
          }

          .tab-button {
            flex: 1 1 50%;
            padding: 1rem;
            font-size: 0.9rem;
          }

          .tab-button svg {
            display: none;
          }

          .tab-content {
            padding: 1.5rem;
          }

          .symptom-card-new {
            padding: 1.2rem;
            border-radius: 12px;
          }

          .symptom-name-new {
            font-size: 1rem;
            margin-bottom: 0.5rem;
          }

          .symptom-desc-new {
            font-size: 0.9rem;
          }

          .treatment-timeline {
            padding-left: 1.5rem;
          }

          .treatment-item {
            padding-left: 1.5rem;
            margin-bottom: 1.5rem;
          }

          .treatment-item::before {
            left: -2rem;
            width: 14px;
            height: 14px;
          }

          .treatment-title-new {
            font-size: 1.1rem;
          }

          .treatment-desc-new {
            font-size: 0.95rem;
          }

          .icon-list-item {
            padding: 0.9rem 1rem;
            gap: 0.8rem;
          }

          .list-icon-new {
            width: 20px;
            height: 20px;
          }

          .faq-item-new {
            border-radius: 12px;
          }

          .faq-question-new {
            padding: 1.2rem 1.5rem;
            font-size: 1rem;
          }

          .faq-answer-new {
            padding: 0 1.5rem 1.2rem;
            font-size: 0.95rem;
          }

          .info-card {
            padding: 1.5rem;
            border-radius: 15px;
          }

          .info-card-title {
            font-size: 1.2rem;
            margin-bottom: 1.2rem;
          }

          .info-row {
            padding: 0.8rem 0;
          }

          .info-label {
            font-size: 0.85rem;
          }

          .info-value {
            font-size: 0.9rem;
          }

          .cta-title-new {
            font-size: 1.4rem;
          }

          .cta-text-new {
            font-size: 0.9rem;
            margin-bottom: 1.2rem;
          }

          .cta-contacts {
            gap: 0.6rem;
            margin-bottom: 1.2rem;
          }

          .cta-contact-item {
            padding: 0.7rem;
            font-size: 0.85rem;
          }

          .cta-button-new {
            padding: 0.9rem;
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .procedure-hero-compact {
            padding: 1.5rem 0.8rem 1.2rem;
          }

          .hero-content-compact {
            padding: 0 0.8rem;
          }

          .back-link-compact {
            padding: 0.4rem 0.8rem;
            font-size: 0.8rem;
            margin-bottom: 1.2rem;
          }

          .back-link-compact svg {
            width: 16px;
            height: 16px;
          }

          .hero-icon-box {
            width: 70px;
            height: 70px;
            font-size: 2rem;
            border-radius: 15px;
          }

          .category-tag {
            padding: 0.25rem 0.7rem;
            font-size: 0.7rem;
            margin-bottom: 0.5rem;
          }

          .hero-title-compact {
            font-size: 1.6rem;
            line-height: 1.3;
          }

          .hero-subtitle {
            font-size: 0.9rem;
          }

          .hero-meta {
            padding: 1rem;
            gap: 0.5rem;
          }

          .meta-item-hero {
            font-size: 0.85rem;
          }

          .meta-item-hero svg {
            width: 18px;
            height: 18px;
          }

          .contact-strip {
            padding: 0.8rem;
          }

          .contact-strip-content {
            gap: 0.8rem;
          }

          .contact-items {
            gap: 0.6rem;
          }

          .contact-item-strip {
            font-size: 0.85rem;
            gap: 0.6rem;
          }

          .contact-icon {
            width: 32px;
            height: 32px;
          }

          .contact-icon svg {
            width: 16px;
            height: 16px;
          }

          .book-btn-strip {
            padding: 0.7rem 1.5rem;
            font-size: 0.9rem;
            gap: 0.5rem;
          }

          .book-btn-strip svg {
            width: 18px;
            height: 18px;
          }

          .procedure-main {
            padding: 1.5rem 0.8rem;
            gap: 1.2rem;
          }

          .overview-card {
            padding: 1.5rem;
            border-radius: 12px;
            margin-bottom: 1.2rem;
          }

          .overview-title {
            font-size: 1.4rem;
            margin-bottom: 1rem;
          }

          .overview-text {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 1rem;
          }

          .tabs-container {
            border-radius: 12px;
            margin-bottom: 1.2rem;
          }

          .tab-button {
            flex: 1 1 100%;
            padding: 0.9rem;
            font-size: 0.85rem;
          }

          .tab-content {
            padding: 1.2rem;
          }

          .symptoms-cards {
            gap: 0.8rem;
          }

          .symptom-card-new {
            padding: 1rem;
            border-radius: 10px;
          }

          .symptom-name-new {
            font-size: 0.95rem;
            gap: 0.5rem;
          }

          .symptom-name-new svg {
            width: 16px;
            height: 16px;
          }

          .symptom-desc-new {
            font-size: 0.85rem;
            line-height: 1.5;
          }

          .treatment-timeline {
            padding-left: 1.2rem;
          }

          .treatment-timeline::before {
            width: 2px;
          }

          .treatment-item {
            padding-left: 1.2rem;
            margin-bottom: 1.2rem;
          }

          .treatment-item::before {
            left: -1.7rem;
            width: 12px;
            height: 12px;
            border-width: 3px;
          }

          .treatment-title-new {
            font-size: 1rem;
            margin-bottom: 0.4rem;
          }

          .treatment-desc-new {
            font-size: 0.9rem;
            line-height: 1.6;
          }

          .icon-list {
            gap: 0.8rem;
          }

          .icon-list-item {
            padding: 0.8rem 0.9rem;
            gap: 0.7rem;
            border-radius: 10px;
          }

          .list-icon-new {
            width: 18px;
            height: 18px;
          }

          .list-icon-new svg {
            width: 12px;
            height: 12px;
          }

          .icon-list-item span {
            font-size: 0.9rem;
          }

          .faq-section {
            margin-top: 1rem;
          }

          .faq-item-new {
            border-radius: 10px;
            margin-bottom: 0.8rem;
          }

          .faq-question-new {
            padding: 1rem 1.2rem;
            font-size: 0.95rem;
          }

          .faq-question-new svg {
            width: 20px;
            height: 20px;
          }

          .faq-answer-new {
            padding: 0 1.2rem 1rem;
            font-size: 0.9rem;
            line-height: 1.6;
          }

          .sidebar-new {
            gap: 1.2rem;
          }

          .info-card {
            padding: 1.2rem;
            border-radius: 12px;
          }

          .info-card-title {
            font-size: 1.1rem;
            margin-bottom: 1rem;
          }

          .info-row {
            padding: 0.7rem 0;
            flex-direction: column;
            align-items: flex-start;
            gap: 0.3rem;
          }

          .info-label,
          .info-value {
            font-size: 0.85rem;
          }

          .info-value {
            text-align: left;
          }

          .cta-title-new {
            font-size: 1.3rem;
            margin-bottom: 0.8rem;
          }

          .cta-text-new {
            font-size: 0.85rem;
            line-height: 1.5;
            margin-bottom: 1rem;
          }

          .cta-contacts {
            gap: 0.5rem;
            margin-bottom: 1rem;
          }

          .cta-contact-item {
            padding: 0.6rem;
            font-size: 0.8rem;
          }

          .cta-contact-item svg {
            width: 14px;
            height: 14px;
          }

          .cta-button-new {
            padding: 0.8rem;
            font-size: 0.9rem;
            gap: 0.5rem;
          }

          .cta-button-new svg {
            width: 18px;
            height: 18px;
          }
        }

        @media (max-width: 360px) {
          .hero-title-compact {
            font-size: 1.4rem;
          }

          .hero-icon-box {
            width: 60px;
            height: 60px;
            font-size: 1.8rem;
          }

          .overview-title {
            font-size: 1.3rem;
          }

          .tab-button {
            padding: 0.8rem;
            font-size: 0.8rem;
          }

          .symptom-card-new,
          .icon-list-item {
            padding: 0.8rem;
          }

          .treatment-title-new {
            font-size: 0.95rem;
          }

          .faq-question-new {
            padding: 0.9rem 1rem;
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="procedure-detail-redesigned">
        {/* Compact Hero */}
        <section className="procedure-hero-compact">
          <div className="hero-content-compact">
            <Link to="/procedures" className="back-link-compact">
              <ArrowLeft size={18} />
              Back to Procedures
            </Link>

            <div className="hero-grid">
              <div className="hero-icon-box">
                {procedure.icon}
              </div>

              <div className="hero-text">
                <div className="category-tag">{procedure.category}</div>
                <h1 className="hero-title-compact">{procedure.title}</h1>
                <p className="hero-subtitle">{procedure.tagline}</p>
              </div>

              <div className="hero-meta">
                <div className="meta-item-hero">
                  <Clock size={20} />
                  <span>{procedure.duration}</span>
                </div>
                <div className="meta-item-hero">
                  <Stethoscope size={20} />
                  <span>Expert Care</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Strip */}
        <div className="contact-strip">
          <div className="contact-strip-content">
            <div className="contact-items">
              <div className="contact-item-strip">
                <div className="contact-icon">
                  <Phone size={18} />
                </div>
                <a href="tel:+919989162222">+91 99891 62222</a>
              </div>
              <div className="contact-item-strip">
                <div className="contact-icon">
                  <Mail size={18} />
                </div>
                <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
              </div>
            </div>
            <a href="/contact" className="book-btn-strip">
              <Calendar size={20} />
              Book Appointment
            </a>
          </div>
        </div>

        {/* Main Content */}
        <div className="procedure-main">
          <div>
            {/* Overview */}
            <div className="overview-card">
              <h2 className="overview-title">Understanding {procedure.title}</h2>
              <p className="overview-text">{procedure.overview}</p>
              <p className="overview-text">{procedure.whatIsIt}</p>
            </div>

            {/* Tabbed Content */}
            <div className="tabs-container">
              <div className="tabs-header">
                <button 
                  className={`tab-button ${activeTab === 'symptoms' ? 'active' : ''}`}
                  onClick={() => setActiveTab('symptoms')}
                >
                  <AlertCircle size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
                  Symptoms
                </button>
                <button 
                  className={`tab-button ${activeTab === 'causes' ? 'active' : ''}`}
                  onClick={() => setActiveTab('causes')}
                >
                  <Info size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
                  Causes
                </button>
                <button 
                  className={`tab-button ${activeTab === 'treatment' ? 'active' : ''}`}
                  onClick={() => setActiveTab('treatment')}
                >
                  <Shield size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
                  Treatment
                </button>
                <button 
                  className={`tab-button ${activeTab === 'prevention' ? 'active' : ''}`}
                  onClick={() => setActiveTab('prevention')}
                >
                  <Heart size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
                  Prevention
                </button>
              </div>

              <div className="tab-content">
                {/* Symptoms Tab */}
                {activeTab === 'symptoms' && (
                  <div className="symptoms-cards">
                    {procedure.symptoms.map((symptom, index) => (
                      <div key={index} className="symptom-card-new">
                        <div className="symptom-name-new">
                          <AlertCircle size={18} style={{color: '#E86A33'}} />
                          {symptom.name}
                        </div>
                        <div className="symptom-desc-new">{symptom.description}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Causes Tab */}
                {activeTab === 'causes' && (
                  <div className="icon-list">
                    {procedure.causes.map((cause, index) => (
                      <div key={index} className="icon-list-item">
                        <div className="list-icon-new">
                          <AlertCircle size={14} />
                        </div>
                        <span>{cause}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Treatment Tab */}
                {activeTab === 'treatment' && (
                  <div className="treatment-timeline">
                    {procedure.treatments.map((treatment, index) => (
                      <div key={index} className="treatment-item">
                        <div className="treatment-title-new">{treatment.title}</div>
                        <div className="treatment-desc-new">{treatment.description}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Prevention Tab */}
                {activeTab === 'prevention' && (
                  <div className="icon-list">
                    {procedure.prevention.map((tip, index) => (
                      <div key={index} className="icon-list-item">
                        <div className="list-icon-new">
                          <CheckCircle size={14} />
                        </div>
                        <span>{tip}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* FAQ Section */}
            <div className="tabs-container">
              <div className="tabs-header">
                <div className="tab-button active">
                  <BookOpen size={18} style={{display: 'inline', marginRight: '0.5rem'}} />
                  Frequently Asked Questions
                </div>
              </div>
              <div className="tab-content">
                <div className="faq-section">
                  {procedure.faqs.map((faq, index) => (
                    <div 
                      key={index} 
                      className={`faq-item-new ${openFAQ === index ? 'open' : ''}`}
                    >
                      <div 
                        className="faq-question-new"
                        onClick={() => toggleFAQ(index)}
                      >
                        <span>{faq.question}</span>
                        {openFAQ === index ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
                      </div>
                      {openFAQ === index && (
                        <div className="faq-answer-new">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="sidebar-new">
            {/* Quick Info */}
            <div className="info-card">
              <h3 className="info-card-title">Quick Information</h3>
              <div className="info-row">
                <span className="info-label">Duration</span>
                <span className="info-value">{procedure.duration}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Category</span>
                <span className="info-value">{procedure.category}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Specialist</span>
                <span className="info-value">Available</span>
              </div>
            </div>

            {/* CTA Card */}
            <div className="info-card cta-card-new">
              <div className="cta-card-content">
                <h3 className="cta-title-new">Need Consultation?</h3>
                <p className="cta-text-new">
                  Get expert medical advice for your condition
                </p>
                
                <div className="cta-contacts">
                  <div className="cta-contact-item">
                    <Phone size={16} />
                    <a href="tel:+919989162222">+91 99891 62222</a>
                  </div>
                  <div className="cta-contact-item">
                    <Mail size={16} />
                    <a href="mailto:vayulungcare@gmail.com">Email Us</a>
                  </div>
                </div>

                <a href="/contact" className="cta-button-new">
                  <Calendar size={20} />
                  Schedule Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcedureDetailPageRedesigned;